import React, { useRef, useState, useEffect } from "react";
import { Col, Container, Input, Row, Spinner } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { useParams, Link } from "react-router-dom";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { updateselected } from "services/scheduledService";
import api from "../../api";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  getJobRoundDetails,
  getJobRoundDetailsWithParams,
  fetchHighQualifications,
  getAdminFeedbackData,
  getCandidateNotes,
  removeCandidateNotes,
  getRemarks,
} from "helpers/backend_helper";
import filtericon from "../../assets/images/icon/filter-icon.svg";
import cross from "../../assets/images/icon/cross.svg";
import moment from "moment";
import { Form, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  archiveApplication,
  createfeedback,
  FetchFilterInfo,
  fetchNextRoundData,
  multiRoundStatusUpdate,
  multiStatusUpdate,
  sendBulkAssessment,
  updatestatus,
} from "services/pendingService";
import Dropdown from "react-bootstrap/Dropdown";
import { GetJobList } from "services/JobService";
import { MultiSelect } from "react-multi-select-component";
import { toast } from "react-toastify";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { RangeSlider } from "rsuite";
import location from "../../assets/images/icon/location.svg";
import calender from "../../assets/images/icon/calender-li.svg";
import level from "../../assets/images/icon/level.svg";
import month from "../../assets/images/icon/month.svg";
import years from "../../assets/images/icon/years.svg";
import applieds from "../../assets/images/icon/applied.svg";
import calendar from "../../assets/images/icon/calednder-date.svg";
import eyes_icon from "../../assets/images/icon/eye.png";
import {
  getCompanyTimezoneDateTime,
  getDeviceInfo,
  getSubdomain,
} from "helpers/utils";
import { updateRoundStatus } from "services/screeningService";
import { getInterviewStatus } from "helpers/common";
import { utils } from "react-modern-calendar-datepicker";
import name_icon from "../../assets/images/icon/name01.svg";
import job from "../../assets/images/icon/job-port.svg";
import { getUserInfo, getUserToken } from "helpers/authHelper";
import authHeader from "helpers/jwt-token-access/auth-token-header";
import { decryptDataFromArray } from "helpers/EncDec";
import "rc-slider/assets/index.css";
import TimeslotBookingAdmin from "./../Screening_Test/TimeslotBookingAdmin";
import ButtonLoader from "components/Common/ButtonLoader";
import Swal from "sweetalert2";

import delete_icon from "../../assets/images/icon/delete.svg";
import html_bedge from "../../assets/images/icon/bedge-html.svg";
import star from "../../assets/images/icon/star.svg";
import assessment_icon_img from "../../assets/images/icon/assessment-icon-img.svg";
import education from "../../assets/images/icon/education-role.svg";
import star_exp from "../../assets/images/icon/exp_job.svg";
import RatingStars from "pages/Screening_Test/RatingStars";
import { useTranslation } from "react-i18next";

import user_icons1 from "../../assets/images/icon/user-ico7.svg";
import { faStar,faRemove } from "@fortawesome/free-solid-svg-icons";
import RoundList from "components/RoundList";
import addnotoes from "../../assets/images/icon/addnotoes.svg";
import SearchBar from "components/Common/Searchbar";

export default function JobPosting() {
  const { t } = useTranslation();
  const [actionType, setActionType] = useState("reject");
  const [selectedRemark, setSelectedRemark] = useState(null);
  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [startX, setStartX] = useState(0);
  const [filters, setFilters] = useState({});
  const [scrollLeft, setScrollLeft] = useState(0);
  const [roundStatus, setRoundStatus] = useState("");
  const [isSelected, setisSelected] = useState(false);
  const [comments, setComments] = useState(""); // Initialize comment state
  const [commentsError, setCommentsError] = useState("");
  const [offerLetter, setOfferLetter] = useState(null); // Initialize offerLetter state
  const [remarks, setRemarks] = useState([]);
  const [roundStatusName, setRoundStatusName] = useState(
    t(`ATS View.All Status`)
  );
  const [data, setData] = useState([]);
  const roundTypes = [
    { label: t(`ATS View.Pending`), value: "Pending", modelId: 0 },
    { label: t(`ATS View.Scheduled`), value: "Scheduled", modelId: 1 },
    { label: t(`ATS View.Skipped`), value: "Skipped", modelId: 2 },
    { label: t(`ATS View.On Hold`), value: "On Hold", modelId: 3 },
    { label: t(`ATS View.Completed`), value: "Completed", modelId: 4 },
    { label: t(`ATS View.Shortlisted`), value: "Shortlisted", modelId: 5 },
    { label: t(`ATS View.Not Attempted`), value: "Not Attempted", modelId: 6 },
  ];
  const STATUS_MAP = {
    reject: { code: 5, label: "Rejected" },
    shortlist: { code: 1, label: "Shortlisted" },
    selectcandidate: { code: 3, label: "Selected" },
    hold: { code: 4, label: "Onhold" },
  };
  let { jobId } = useParams();
  const [jobDetails, setJobDetails] = useState({});
  const [rejectedApplicants, setrejectedApplicants] = useState([]);
  const [filteredAssessmentRounds, setFilteredAssessmentRounds] = useState([]);
  const [filteredpendingApplicants, setFilterPendingApplicants] = useState([]);
  const [filteredpreassessmentApplicants, setFilterPreassessmentApplicants] =
    useState([]);
  const [isCommentRequired, setIsCommentRequired] = useState(true);
  const [filteredInprogressApplicants, setFilterInprogressApplicants] =
    useState([]);
  const [filteredselectedApplicants, setFilterselectedApplicants] = useState(
    []
  );
  const [filteredonboardedApplicants, setFilteronboardedApplicants] = useState(
    []
  );
  const [filteredonholdApplicants, setFilteronholdApplicants] = useState([]);
  const [filteredrejectedApplicants, setFilterrejectedApplicants] = useState(
    []
  );
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [sources, setSources] = useState([]);
  const [tags, setTags] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [query, setQuery] = useState("");
  const [isVisibles, setIsVisibles] = useState(false);
  // Multi Status Update
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [stageValue, setStageValue] = useState("");
  const [selectedStage, setSelectedStage] = useState("");

  const [loading, setLoading] = useState(false);

  // Interview Schedules timeslots initilization
  const [isTimeslotBtnDisabled, setIsTimeslotBtnDisabled] = useState(true);
  const [showTimeslotBooking, setShowTimeslotBooking] = useState(false);
  const [timeSlotsData, settimeSlotsData] = useState({});
  const [selectedStartTime, setSelectedStartTime] = useState("");
  const [selectedEndTime, setSelectedEndTime] = useState("");
  const [sDateTimeSlots, setsDateTimeSlots] = useState([]);
  const [eDateTimeSlots, seteDateTimeSlots] = useState([]);
  const [daytimeSlots, setDaytimeSlots] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [bookedTimeSlots, setbookedTimeSlots] = useState([]);
  const [isFeedback, setIsFeedback] = useState(false);
  const [ErrorsTimeslots, setErrorsTimeslots] = useState({}); // State to track validation errors
  const [ctcOffered, setCtcOffered] = useState(0);

  // Dummy function to handle filtering based on selection
  const [filter, setFilter] = useState("all");
  const [isReject, setIsReject] = useState(false);
  const reject_close = () => {
    setIsReject(false);
    setCommentError("");
  };

  const comment_close = () => {
    setCommentError("");
  };

  useEffect(() => {
    if (isReject && actionType === "reject") {
      fetchRemarks();
    } else {
      // reset when switching action
      setRemarks([]);
      setSelectedRemark(null);
      setComment("");
      setCommentError("");
    }
  }, [isReject, actionType]);

  const handleRemarkChange = e => {
    console.log("okokok");
    const remarkId = e.target.value;
    const remark = remarks.find(r => r.id == remarkId);
    console.log(remark, "selectedremarks");
    setSelectedRemark(remark);

    // Optional: auto-fill comment
    // setComment(remark?.remark_label || "");
  };

  console.log(remarks, "remarks");
  const handleActionSubmit = () => {
    if (!STATUS_MAP[actionType]) {
      console.error("Invalid action type:", actionType);
      return;
    }

    const trimmedComment = comment.trim();
    console.log(selectedRemark, "selectedRemark ATS");

    if (actionType === "reject") {
      if (!selectedRemark) {
        setCommentError("Please select rejection reason");
        return;
      }

      if (selectedRemark.is_comment_required && !trimmedComment) {
        setCommentError("Comment is required");
        return;
      }
    }
    console.log(
      actionType !== "reject" && isCommentRequired && !trimmedComment,
      "commented"
    );
    if (actionType !== "reject" && isCommentRequired && !trimmedComment) {
      setCommentError("Comment is required");
      return;
    }

    setCommentError("");

    handleConfirm(
      candidateDetails.appl_id,
      STATUS_MAP[actionType].code,
      trimmedComment,
      STATUS_MAP[actionType].label,
      selectedRemark?.id || null
    );
  };

  const formatStage = (value = "") =>
    value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

  const validateComment = () => {
    if (isCommentRequired && !comment.trim()) {
      setCommentError(t(`all-application.Comment required`));
      return false;
    }
    // You can add more validation rules here if needed
    return true;
  };

  const handleConfirm = async (
    appl_id,
    status,
    comment,
    new_status = "Reject",
    remark_id = null
  ) => {
    let otherDetails = {};
    const previousStage = formatStage(selectedStage || "");
    if (new_status) {
      otherDetails = {
        old_status: `${previousStage} Applications`,
        new_status: `${new_status} Applications`,
      };
    }

    await updatestatus(appl_id, status, comment, 0, remark_id, otherDetails)
      .then(res => {
        if (res.status === 200) {
          if (status === 5) {
            toast.success(t(`all-application.Record Rejected`));
          } else if (status === 4) {
            toast.success(t(`all-application.Record Onhold`));
          } else {
            toast.success(t(`all-application.Comment Added`));
          }
          setLoading(false);
          fetchJobDetails();
          setSelectedCandidates([]);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch(error => {
        // console.log(error);
        toast.error(error);
      });
    comment_close();
    hold_close();
    reject_close();
  };

  const hold_close = () => {
    
    setCommentError("");
  };

  const fetchRemarks = async () => {
    try {
      const res = await getRemarks("reject");
      console.log(res.data, "Remarks");
      setRemarks(res.data); // or res.data.data (check API)
    } catch (err) {
      console.error(err);
    }
  };

  const handleFilterChange = event => {
    const selectedFilter = event.target.value;
    setFilter(selectedFilter); // Update the selected filter state

    let filteredApplicants;

    if (selectedFilter === "rejected") {
      // Show only applicants where is_auto_rejected is 0
      filteredApplicants = rejectedApplicants.filter(
        applicant => applicant.is_auto_rejected === 0
      );
    } else if (selectedFilter === "auto-rejected") {
      // Show only applicants where is_auto_rejected is 1
      filteredApplicants = rejectedApplicants.filter(
        applicant => applicant.is_auto_rejected === 1
      );
    } else {
      // "all" case: Show all rejected applicants
      filteredApplicants = rejectedApplicants;
    }

    setFilterrejectedApplicants(filteredApplicants); // Update the state with the filtered applicants
  };

  // Day to integer map
  const dayToIntegerMap = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  const stageOptions = [
    { label: "Select Stage", value: "" },

    { label: t(`ATS View.New Applications`), value: "pending" },

    ...(getSubdomain() === "mahindra"
      ? [{ label: t(`ATS View.In_Progress_Applications`), value: "inprogress" }]
      : []),

    { label: t(`ATS View.Onhold Applications`), value: "hold" },
    { label: t(`ATS View.Rejected Applications`), value: "rejected" },
    { label: t(`ATS View.Archived Applications`), value: "archive" },
    { label: t(`ATS View.selected_application`), value: "selected" },
  ];

  // Assessment Modal Changes
  const userInfo = getUserInfo();
  const teamsIntegrated = userInfo?.teams_integration || false;
  const [errors, setErrors] = useState("");
  const [roundListData, setRoundListData] = useState([]);
  const interviewStatus = [
    { value: "0", label: t(`ATS View.Pending`) },
    { value: "2", label: t(`ATS View.Skip`) },
    { value: "3", label: t(`ATS View.On Hold`) },
    { value: "4", label: t(`ATS View.Completed`) },
    { value: "5", label: t(`ATS View.Shortlisted`) },
    { value: "6", label: t(`ATS View.Not Attempted`) },
  ];
  const [roundStatusAssessment, setRoundStatusAssessment] = useState(null);
  const [interviewType, setInterviewType] = useState("");
  const [interViewers, setinterViewers] = useState([]);
  const [assessmentModal, setAssessmentModal] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [formData, setFormData] = useState({
    int_schedule_date: "",
    int_schedule_time: "",
    interview_title: "",
    interviewer_time: interViewers?.[0]?.value,
    address: "",
    req_documents: "",
    meeting_type: 0,
    teams_interview: false,
  });
  const [candidateDetails, setCandidateDetails] = useState({});
  const [commentError, setCommentError] = useState("");
  const [comment, setComment] = useState("");
  const [selectedApplId, setSelectedApplId] = useState(null);
  const [selectedCandidate, setSelectedCandidate] = useState({
    name: "",
    roleType: "",
    user_id: "",
    vacancy_id: "",
    candidate_photo: "",
  });

  const [int_start_time, setStartTime] = useState("");
  const [int_end_time, setEndTime] = useState("");
  const [categoryRatings, setCategoryRatings] = useState({
    Behavior: 0,
    Psychometric: 0,
    Technical: 0,
    Numerical: 0,
  });
  const categories = [
    { name: t(`ATS View.Behavior`), totalStars: 5 },
    { name: t(`ATS View.Psychometric`), totalStars: 5 },
    { name: t(`ATS View.Technical`), totalStars: 5 },
    { name: t(`ATS View.Numerical`), totalStars: 5 },
  ];

  // Assesment Center new Design Variables
  const [activeIndex, setActiveIndex] = useState(null);
  const [feedbackInfo, setFeedbackInfo] = useState("");
  const [allNotes, setAllNotes] = useState([]);
  const [readMoreStates, setReadMoreStates] = useState({});
  const [activeTab, setActiveTab] = useState("tab1");
  const [showModal, setShowModal] = useState(false);
  const [showNotes, setShowNotes] = useState(false);

  const toggleAccordion = index => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  const APPLICANT_GROUPS = {
    // assessment: filteredpreassessmentApplicants,
    pending: filteredpendingApplicants,
    inprogress: filteredInprogressApplicants,
    selected: filteredselectedApplicants,
    onboarded: filteredonboardedApplicants,
    hold: filteredonholdApplicants,
    rejected: filteredrejectedApplicants,
  };
  // Check if a user is selected
  const isCandidateChecked = user =>
    selectedCandidates.some(sel => sel.appl_id === user.appl_id);

  // Check if ALL candidates of a group are selected
  const isAllGroupSelected = groupKey => {
    const list = APPLICANT_GROUPS[groupKey] || [];
    if (!list.length) return false;

    return list.every(app =>
      selectedCandidates.some(sel => sel.appl_id === app.appl_id)
    );
  };

  const handleNotes = () => setShowNotes(!showNotes);

  const handleCloseModal = () => setShowNotes(!showNotes);

  const fetchCandidateNotes = async () => {
    if (!selectedCandidate?.appl_id) {
      return;
    }
    await getCandidateNotes(selectedApplId || selectedCandidate?.appl_id)
      .then(res => {
        setAllNotes(res?.data || []);
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`View Details.Something went wrong`);
        toast.error(errMsg);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      if (selectedApplId || selectedCandidate?.appl_id) {
        try {
          const res = await getAdminFeedbackData(
            selectedApplId || selectedCandidate?.appl_id
          );
          let responseData = decryptDataFromArray(res);
          setFeedbackInfo(responseData?.data || {});
        } catch (error) {
          console.error("Error fetching feedback data:", error);
        }
      }
    };

    fetchData();
    fetchCandidateNotes();
  }, [selectedApplId, selectedCandidate?.appl_id, assessmentModal]);

  const handleRemoveNote = async item => {
    if (!selectedApplId || !item) {
      return;
    }
    if (item?.admin_id !== userInfo?.id) {
      toast.warn(
        t(`View Details.Notes can only be modified by admin who created it!`)
      );
      return;
    }
    await removeCandidateNotes(selectedApplId, { noteId: item?.id })
      .then(res => {
        toast.success(t(`View Details.Note Removed Successfully!`));
        fetchCandidateNotes();
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`View Details.Something went wrong`);
        toast.error(errMsg);
      });
  };
  const toggleReadMore = id => {
    setReadMoreStates(prevState => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };
  const handleCopyLink = async linkToCopy => {
    try {
      await navigator.clipboard.writeText(linkToCopy);
      toast.success("The link has been copied to your clipboard!");
    } catch (error) {
      toast.error("Unable to copy the link");
      console.error("Failed to copy text: ", error);
    }
  };

  const handleShow = () => setShowModal(true);
  const handleClose = () => {
    setShowModal(false);
    setAssessmentModal(true);
  };

  //Final Code block

  const handleMouseDown = e => {
    if (scrollRef.current) {
      setIsDragging(true);
      setStartX(e.pageX - scrollRef.current.offsetLeft);
      setScrollLeft(scrollRef.current.scrollLeft);
    }
  };

  const handleStateChange = e => {
    setFilters({
      ...filters,
      state: e,
      // city: "",
    });
    let cityList = cities?.filter(el => el?.state_id === parseInt(e.value));
    setFilteredCities(cityList);
  };

  const getFilterInfo = async () => {
    await FetchFilterInfo()
      .then(res => {
        let filterData = res?.data?.data || "";
        if (filterData) {
          setCities(filterData?.cities || []);
          setStates(filterData?.states || []);
          setSources(filterData?.sources || []);
          setTags(filterData?.tagList || []);
          setSkillList(filterData?.skillList || []);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleMouseMove = e => {
    if (isDragging && scrollRef.current) {
      const x = e.pageX - scrollRef.current.offsetLeft;
      const walk = (x - startX) * 3; // Adjust scrolling speed
      scrollRef.current.scrollLeft = scrollLeft - walk;
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const fetchJobDetails = async () => {
    await getJobRoundDetails(jobId)
      .then(response => {
        let responseData = decryptDataFromArray(response);
        setJobDetails(responseData?.data || {});
        setFilteredAssessmentRounds(responseData?.data?.assessmentRounds || []);
        setFilterPendingApplicants(responseData?.data?.pendingApplicants || []);
        setFilterPreassessmentApplicants(
          responseData?.data?.preassessmentApplicants || []
        );
        setFilterselectedApplicants(
          responseData?.data?.selectedApplicants || []
        );
        setFilterInprogressApplicants(
          responseData?.data?.screeningScheuledApplicants || []
        );
        setFilteronboardedApplicants(
          responseData?.data?.onboardedApplicants || []
        );
        setFilteronholdApplicants(responseData?.data?.onholdApplicants || []);
        setrejectedApplicants(responseData?.data?.rejectedApplicants || []);
        setFilterrejectedApplicants(
          responseData?.data?.rejectedApplicants || []
        );
      })
      .catch(err => {});
  };
  //New Job details Fetch Filter
  const fetchJobDetailsWithFilter = async () => {
    await getJobRoundDetailsWithParams(jobId, {
      ...filters,
      round_status: roundStatus,
      queryText: query,
    })
      .then(response => {
        let responseData = decryptDataFromArray(response);
        // let responseData = response;
        setJobDetails(responseData?.data || {});
        setFilteredAssessmentRounds(responseData?.data?.assessmentRounds || []);
        setFilterPendingApplicants(responseData?.data?.pendingApplicants || []);
        setFilterPreassessmentApplicants(
          responseData?.data?.preassessmentApplicants || []
        );
        setFilterselectedApplicants(
          responseData?.data?.selectedApplicants || []
        );
        setFilterInprogressApplicants(
          responseData?.data?.screeningScheuledApplicants || []
        );
        setFilteronboardedApplicants(
          responseData?.data?.onboardedApplicants || []
        );
        setFilteronholdApplicants(responseData?.data?.onholdApplicants || []);
        setrejectedApplicants(responseData?.data?.rejectedApplicants || []);
        setFilterrejectedApplicants(
          responseData?.data?.rejectedApplicants || []
        );
        setFilterModal(false);
      })
      .catch(err => {});
  };

  const handleAssessmentLinkSend = async (round_id, type) => {
    let confirmation = "";
    if (type === "assessment") {
      confirmation = window.confirm(
        t(`ATS View.Send Assessment Link to Selected Applicants?`)
      );
    }
    if (confirmation || type === "nextRound") {
      setLoading(true);
      let applicationIds = selectedCandidates?.map(el => el?.appl_id);
      let roundId = round_id;
      let payload = {
        applicationIds: applicationIds,
        vacancyId: jobId,
        roundId: roundId,
        type: type,
      };
      await sendBulkAssessment(payload)
        .then(res => {
          setLoading(false);
          fetchJobDetails();
          setSelectedCandidates([]);
          toast.success(t(`ATS View.Status Updated Successfully`));
        })
        .catch(err => {
          let errMsg =
            err?.response?.data?.message || t(`ATS View.Something Went Wrong`);
          toast.error(errMsg);
          setLoading(false);
        });
    }
  };

  // const getQualificationData = () => {
  //   let subdomain = localStorage.getItem("subdomain") || "";
  //   const highqualificationIndia = getFilterStatus(5);
  //   const highqualificationAU = getFilterStatus(6);
  //   if (!subdomain) {
  //     return highqualificationIndia;
  //   }

  //   if (subdomain === "neuronimbus") {
  //     return highqualificationIndia;
  //   }
  //   if (subdomain === "youngunns") {
  //     return highqualificationAU;
  //   }
  //   return highqualificationIndia;
  // };

  const [qualdropdown, setQualDropdown] = useState([]);
  const getQualificationData = async () => {
    try {
      const qualifications = await fetchHighQualifications();
      setQualDropdown(qualifications); // Directly set the response
    } catch (error) {
      console.error("Error fetching qualifications:", error);
      setQualDropdown([]);
    }
  };

  useEffect(() => {
    console.log("fetchJobDetailsWithFilteruseeffect");
    fetchJobDetailsWithFilter();

    GetJobList().then(res => {
      let responseData = res.data;
      responseData = decryptDataFromArray(responseData);

      if (responseData?.status) {
        setData(responseData?.data);
      }
    });
    getFilterInfo();
    fetchinterViewers();
    getQualificationData();
    document.title = "NeuroTal - Positions";
  }, [window.location.pathname]);

  const history = useHistory();

  const toggleFilterModal = () => {
    setFilterModal(!filterModal);
    // clearFilters();
  };

  const clearFilters = () => {
    setFilters({});
    setErrors(prevErrors => ({
      ...prevErrors,
      submitButton: "",
    }));
  };

  const hanldeBulkRoundStatusChange = async (e, roundData) => {
    if (e?.value === "assessment" || e?.value === "nextRound") {
      await handleAssessmentLinkSend(roundData?.id, e?.value);
      return;
    }
    setLoading(true);
    let applicationData = selectedCandidates?.map(el => {
      return {
        appl_id: el?.appl_id,
        currentStage: el?.currentStage,
        roundName: el?.roundName,
        roundStatus: el?.roundStatus,
      };
    });
    let payload = {
      applicationData: applicationData,
      status: e?.modelId,
      new_status: `${roundData?.interview_title} - ${e?.label}`,
      roundId: roundData?.id,
      roundType: roundData?.round_type,
    };

    await multiRoundStatusUpdate(payload)
      .then(res => {
        setLoading(false);
        setSelectedCandidates([]);
        fetchJobDetails();
        toast.success(t(`ATS View.Status Updated Successfully`));
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message || t(`ATS View.Something Went Wrong`);
        toast.error(errMsg);
        setLoading(false);
      });
  };

  function safeParseJSON(jsonString) {
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      console.error("Invalid JSON string provided:", e);
      return null;
    }
  }

  // New Function
  const handleSubmit = click => {
    if (Object.keys(filters).length === 0 && click?.type === "click") {
      setErrors(prevErrors => ({
        ...prevErrors,
        submitButton: t(`ATS View.Please select a value to proceed`),
      }));
      return false;
    } else {
      setErrors(prevErrors => ({
        ...prevErrors,
        submitButton: "",
      }));
      fetchJobDetailsWithFilter();
      console.log("fetchJobDetailsWithFilterhandleSubmit");
    }
  };

  const getFilterList = () => {
    let filterArray = [];
    let allFilters = JSON.parse(JSON.stringify(filters));
    Object.keys(allFilters)?.map(el => {
      let label = el?.split("_")?.join(" ");
      let values = allFilters[el];
      if (
        el !== "relevancy_score" &&
        el !== "total_experience" &&
        el !== "behavioural_score" &&
        el !== "start_date" &&
        el !== "end_date"
      ) {
        if (values?.length > 0) {
          values = values?.map(item => item?.label)?.join(", ");
        } else {
          values = [values?.label];
        }
      } else if (el === "start_date" || el === "end_date") {
        values = `${moment(getCompanyTimezoneDateTime(values)).format(
          "Do MMM YYYY"
        )}`;
      } else {
        values = values?.join(" to ");
      }
      filterArray.push({
        label: label,
        value: values,
        key: el,
      });
      return el;
    });
    return filterArray;
  };

  const handleSelectCandidate = (checked, user, selected_stage = null) => {
    setSelectedStage(selected_stage);
    setSelectedCandidates(prev => {
      if (checked) {
        return [...prev, user];
      }
      return prev.filter(el => el.appl_id !== user.appl_id);
    });
  };

  const handleSelectCandidateMulti = (checked, groupKey) => {
    const users = APPLICANT_GROUPS[groupKey] || [];

    setSelectedCandidates(prev => {
      // Remove existing users of this group
      const remaining = prev.filter(
        el => !users.some(u => u.appl_id === el.appl_id)
      );

      // If checked → add all
      if (checked) {
        return [...remaining, ...users];
      }

      // If unchecked → remove all
      return remaining;
    });
  };

  const isCandidateSelected = user => {
    let allCandidates = JSON.parse(JSON.stringify(selectedCandidates));
    let userExist = allCandidates?.find(el => el?.email_id === user?.email_id);
    if (userExist) {
      return true;
    }
    return false;
  };
  const toggleCommentRequirement = () => {
    setIsCommentRequired(prevIsCommentRequired => !prevIsCommentRequired);
  };
  const handleMultiStatusApply = async () => {
    if (!stageValue) {
      toast.error(t(`ATS View.Please Select Stage!`));
      return false;
    }
    if (stageValue === selectedStage) {
      toast.error(t(`ATS View.NextStage`));
      return false;
    }
    setLoading(true);
    let applicationData = selectedCandidates?.map(el => {
      return {
        appl_id: el?.appl_id,
        currentStage: el?.currentStage,
      };
    });
    let payload = {
      applicationData: applicationData,
      stageValue: stageValue,
      new_status: stageOptions?.find(el => el?.value === stageValue)?.label,
    };
    if (stageValue === "inprogress") {
      const applIds = applicationData.map(item => item.appl_id);
      open_slider(applIds[0], 1);
      setActionType("shortlist");
      setIsReject(true);
      setLoading(false);
    } else if (stageValue === "rejected") {
      const applIds = applicationData.map(item => item.appl_id);
      open_slider(applIds[0], 5);
      setActionType("reject");
      setIsReject(true);
      setLoading(false);
    } else if (stageValue === "archive") {
      await archiveApplication(payload)
        .then(res => {
          setLoading(false);
          fetchJobDetails();
          setSelectedCandidates([]);
          toast.success(t(`ATS View.Applications archived Successfully!`));
        })
        .catch(err => {
          let errMsg =
            err?.response?.data?.message || t(`ATS View.Something Went Wrong`);
          toast.error(errMsg);
          setLoading(false);
        });
    } else if (stageValue === "selected") {
      const applIds = applicationData.map(item => item.appl_id);
      open_slider(applIds[0], 3);
      setisSelected(!isVisibles);
      setLoading(false);
    } else {
      await multiStatusUpdate(payload)
        .then(res => {
          setLoading(false);
          fetchJobDetails();
          setSelectedCandidates([]);
          toast.success(t(`ATS View.Data Updated Successfully!`));
        })
        .catch(err => {
          let errMsg =
            err?.response?.data?.message || t(`ATS View.Something Went Wrong`);
          toast.error(errMsg);
          setLoading(false);
        });
    }
  };

  const handleArchiveAppplication = async user => {
    Swal.fire({
      title: t(`ATS View.warning`),
      text: t(`ATS View.Archive Application`),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t(`ATS View.Yes`),
      cancelButtonText: t(`ATS View.Cancel`),
    })
      .then(async result => {
        if (result.isConfirmed) {
          setLoading(true);
          let applicationData = [
            {
              appl_id: user?.appl_id,
              currentStage: user?.currentStage,
            },
          ];
          let payload = {
            applicationData: applicationData,
            new_status: "Archived Applications",
          };
          await archiveApplication(payload)
            .then(res => {
              setLoading(false);
              fetchJobDetails();
              setSelectedCandidates([]);
              toast.success(t(`ATS View.Applications archived Successfully!`));
            })
            .catch(err => {
              let errMsg =
                err?.response?.data?.message ||
                t(`ATS View.Something Went Wrong`);
              toast.error(errMsg);
              setLoading(false);
            });
        }
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message || t(`ATS View.Something Went Wrong`);
        toast.error(errMsg);
        setLoading(false);
      });
  };

  useEffect(() => {
    handleSubmit();
  }, [roundStatus]);

  useEffect(() => {
    if (!filterModal) {
      handleSubmit();
    }
  }, [filters]);

  // Assessment Modal Funcs

  const fetchinterViewers = async () => {
    await api
      .get(`${process.env.REACT_APP_API_URL}/admin/user/fetch-user`)
      .then(response => {
        let { userList, success } = decryptDataFromArray(response?.data);
        let data = userList?.map(item => ({
          id: item?.id,
          label: item?.name,
          value: item?.id,
        }));
        setinterViewers(data);
      })
      .catch(err => console.log("Error:::", err));
  };

  const handleFilterRemove = key => {
    let allFilters = JSON.parse(JSON.stringify(filters));
    delete allFilters[key];
    setFilters(allFilters);
    // handleSubmit();
  };

  const handleAssessmentStart = async (
    vacancy_id,
    user_id,
    appl_id,
    name,
    roleType,
    createdAt,
    allInfo
  ) => {
    setRoundStatusAssessment(null);
    setAssessmentModal(true);
    setSelectedApplId(appl_id);
    const date = new Date(createdAt);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
    const formattedDate = new Intl.DateTimeFormat("en-GB", options).format(
      date
    );
    setSelectedCandidate({
      name: name,
      roleType: roleType,
      user_id: user_id,
      vacancy_id: vacancy_id,
      appl_id: appl_id,
      createdAt: formattedDate,
      allInfo: allInfo,
      candidate_photo: allInfo?.job_user?.candidate_photo,
    });
    let payload = {
      appl_id: appl_id,
      // vacancy_id: vacancy_id,
      // user_id: user_id,
    };
    await fetchRoundsData(payload);
  };

  const fetchRoundsData = async payload => {
    await fetchNextRoundData(payload)
      .then(res => {
        if (res?.data?.success) {
          setRoundListData(res?.data?.data || []);
        } else {
          toast.error(t(`ATS View.No data available`));
        }
      })
      .catch(err => console.log(err));
  };

  const handleUpdateRoundStatus = async (
    id,
    roundId,
    old_status,
    roundName,
    roundType,
    user_id,
    vacancy_id
  ) => {
    if (!roundStatus) {
      toast.error(t(`ATS View.Round Status is Required`));
      return false;
    }
    let payload = {
      roundType: roundType,
      appl_id: selectedApplId,
      intr_id: id,
      status: roundStatus,
      roundId: roundId,
      old_status: roundName + " - " + old_status,
      new_status: roundName + " - " + getInterviewStatus(roundStatus),
      user_id: user_id,
      vacancy_id: vacancy_id,
    };
    await updateRoundStatus(payload)
      .then(res => {
        fetchRoundsData({ appl_id: selectedApplId });
        fetchJobDetails();
        toast.success(t(`ATS View.Round Status Updated Successfully`));
      })
      .catch(err => {
        let errMsg =
          err?.response?.message ||
          err?.response?.data?.msg ||
          t(`ATS View.Something Went Wrong`);
        toast.error(errMsg);
      });
  };

  const handleToggleForm = () => {
    setIsFormVisible(prev => !prev);
  };

  const handleScreenTest = async (
    round_id,
    appl_id,
    user_id,
    vacancy_id,
    status
  ) => {
    try {
      const confirmed = window.confirm(
        t(`ATS View.Are you sure you want to send the link?`)
      );

      if (!confirmed) {
        return;
      }
      let authUser = JSON.parse(localStorage.getItem("authUser"));
      let adminId = authUser.user.id;
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/admin/pending/update-screening`,
        {
          round_id,
          appl_id: selectedCandidate?.appl_id || "",
          user_id,
          vacancy_id,
          status,
          adminId,
        },
      );

      if (response.status === 200) {
        toast.success(t(`ATS View.Link Sent successfully`));
        fetchRoundsData({ appl_id: selectedCandidate?.appl_id });
        fetchJobDetails();
      } else {
        toast.error(t(`ATS View.Failed to send link`));
      }
      // handleCloseAssessmentModal();
    } catch (error) {
      toast.error(t(`ATS View.Error`) + error.message);
    }
  };

  const getRoundIsOnlineOeOff = roundName => {
    let roundInfo = roundListData.filter(el => el?.roundName == roundName);
    return roundInfo[0]?.interviewDetails
      ? roundInfo[0]?.interviewDetails?.meeting_type
      : roundInfo[0]?.meeting_type;
  };

  const handleInterviewModal = (
    roundId,
    roundType,
    roundName,
    roundStatus,
    meeting_type,
    interviewed_id,
    itr_type,
    itr_details
  ) => {
    setAssessmentModal(false);
    setInterviewType(itr_type);
    setIsFormVisible(prev => !prev);
    meeting_type = getRoundIsOnlineOeOff(roundName) || 0;
    if (itr_type === "schedule") {
      setFormData({
        interviewer_time: interViewers?.[0]?.value,
        address: "",
        req_documents: "",
        meeting_type: meeting_type,
        teams_interview: false,
        roundId: roundId,
        roundType: roundType,
        interview_title: roundName,
        roundStatus: roundStatus,
      });
    } else {
      let interviewer = interViewers?.find(
        el => el?.id === itr_details?.interviewDetails?.user?.id
      );
      setFormData({
        interviewer_time: interviewer?.value || interViewers[0]?.value,
        address: "",
        req_documents: "",
        meeting_type: meeting_type,
        teams_interview: false,
        roundId: roundId,
        roundType: roundType,
        interview_title: roundName,
        roundStatus: roundStatus,
        itr_id: itr_details?.interviewDetails?.id,
      });
    }
  };
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChanges = selected => {
    setSelectedOptions(selected);

    const allinterviewer = selected?.map(interviewer => interviewer.value);
    //console.log("allinterviewer", allinterviewer);
    setFormData(prevState => ({
      ...prevState,
      interviewer_time: allinterviewer,
    }));
  };
  const changeHandlers = e => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
    setErrors({
      ...errors,
      [e.target.name]: "",
    });

    // Conditionally call clearDtTime for specific fields
    if (name === "interviewer_time") {
      clearDtTime();
      setIsTimeslotBtnDisabled(true); // Disable Add TimeSlots button
      setShowTimeslotBooking(false); // Hide TimeslotBookingAdmin
    } else {
      // Enable the button if interviewer_time is valid
      const interviewerID = formData?.interviewer_time || 0;
      setIsTimeslotBtnDisabled(interviewerID <= 0);
    }
  };

  const handleCloseAssessmentModal = () => {
    setAssessmentModal(!assessmentModal);
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    // Validate int_schedule_date
    if (!int_start_time) {
      newErrors.int_start_time = t(`ATS View.This field is required`);
      valid = false;
    }

    // Validate int_schedule_time
    if (!int_end_time) {
      newErrors.int_end_time = t(`ATS View.This field is required`);
      valid = false;
    }

    // Validate starttime
    if (!selectedStartTime) {
      newErrors.selectedStartTime = t(`ATS View.This field is required`);
      valid = false;
    }

    // Validate endtime
    if (!selectedEndTime) {
      newErrors.selectedEndTime = t(`ATS View.This field is required`);
      valid = false;
    }

    // Create DateTime strings by combining the date and time
    const startDateTime = new Date(
      `${int_start_time.split("T")[0]}T${selectedStartTime}`
    );
    const endDateTime = new Date(
      `${int_end_time.split("T")[0]}T${selectedEndTime}`
    );

    if (Date.parse(startDateTime) - Date.parse(new Date()) < 0) {
      newErrors.int_start_time = t(
        `ATS View.Start Date & Time cannot be in the past`
      );
      valid = false;
    }
    if (Date.parse(endDateTime) - Date.parse(startDateTime) < 0) {
      newErrors.int_end_time = t(
        `ATS View.End Date & Time cannot be before Start Date & Time`
      );
      valid = false;
    }

    // Check if start date + time is the same as end date + time
    if (startDateTime.getTime() === endDateTime.getTime()) {
      newErrors.int_end_time = t(
        `ATS View.End Date & Time and Start Date & Time cannot be the same`
      );
      valid = false;
    }

    // Calculate the difference in milliseconds
    const timeDiffMs =
      new Date(endDateTime).getTime() - new Date(startDateTime).getTime();

    // Convert milliseconds to hours
    const timeDiffHours = timeDiffMs / (1000 * 60 * 60); // milliseconds to hours

    // Check if the difference exceeds 3 hours
    if (timeDiffHours > 3) {
      newErrors.int_end_time = t(
        `ATS View.Cannot schedule interview of more than 3 hours`
      );
      valid = false;
    }

    // Validate interview_title
    if (!formData.interview_title) {
      newErrors.interview_title = t(`ATS View.Interview title is required`);
      valid = false;
    }

    // Validate interviewer_time
    if (!formData.interviewer_time) {
      newErrors.interviewer_time = t(`ATS View.Interviewer is required`);
      valid = false;
    }

    // Validate address
    if (!formData.address && formData.meeting_type === 0) {
      newErrors.address = t(`ATS View.Address is required`);
      valid = false;
    }
    if (
      !formData.address &&
      formData.meeting_type === 1 &&
      !formData?.teams_interview
    ) {
      newErrors.address = t(`ATS View.Meeting Link is required`);
      valid = false;
    }

    // Validate req_documents
    // if (!formData.req_documents) {
    //   newErrors.req_documents = "Valid Documents are required";
    //   valid = false;
    // }

    setErrors(newErrors);
    return valid;
  };

  const convertDateFormat = dateString => {
    // Create a new Date object from the given date string
    const dateObject = new Date(dateString);

    // Extract year, month, and day from the date object
    const year = dateObject.getFullYear();
    // Months are zero-based, so we add 1 to get the correct month
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");

    // Construct the formatted date string
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  };

  const handleRescheduleSubmit = async e => {
    e.preventDefault();

    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    const startDateTimeString = `${moment(
      getCompanyTimezoneDateTime(int_start_time)
    ).format("YYYY-MM-DD")}T${selectedStartTime}`;
    const endDateTimeString = `${moment(
      getCompanyTimezoneDateTime(int_end_time)
    ).format("YYYY-MM-DD")}T${selectedEndTime}`;

    let ChangedEventDate = moment(
      getCompanyTimezoneDateTime(startDateTimeString)
    ).utc();
    let ChangedEndEventDate = moment(
      getCompanyTimezoneDateTime(endDateTimeString)
    ).utc();

    let newFormData = JSON.parse(JSON.stringify(formData));

    const dynamicApplId = newFormData?.itr_id;
    const formattedDate = convertDateFormat(ChangedEventDate);
    newFormData.int_schedule_date = formattedDate;
    newFormData.int_start_time = ChangedEventDate;
    newFormData.int_end_time = ChangedEndEventDate;
    newFormData.time_zone_id = userInfo?.company_time_zone_id;
    let device_info = await getDeviceInfo(navigator);
    let roundItem = roundListData?.find(el => el?.isCurrentRound);
    newFormData = {
      ...newFormData,
      device_info: device_info,
      old_status: roundItem?.roundName + " - " + roundItem?.roundStatus,
      new_status: roundItem?.roundName + " - Rescheduled",
      appl_id: selectedApplId,
    };
    try {
      api.post(
        `${process.env.REACT_APP_API_URL}/admin/schedule/update-reschedule/${dynamicApplId}`,
        newFormData
      );
      toast.success(t(`ATS View.Interview Rescheduled successfully`));
      setIsFormVisible(false);
      fetchRoundsData({ appl_id: selectedApplId });
      clearDtTime();
    } catch (error) {
      toast.error(t(`ATS View.Error rescheduling interview`));
    }
  };

  const handleStartDateChange = date => handleDateChange(date, "start");
  const handleEndDateChange = date => handleDateChange(date, "end");

  const checkSameStageSelected = (stage, type) => {
    if (selectedCandidates?.length === 0 || !stage) {
      return false;
    }
    let allCandidates = JSON.parse(JSON.stringify(selectedCandidates)) || [];
    let selectCandidates = [];
    if (type === "assessment") {
      selectCandidates =
        allCandidates?.filter(el => el?.roundName !== stage) || [];
    } else {
      selectCandidates =
        allCandidates?.filter(el => el?.currentStage !== stage) || [];
    }
    return selectCandidates?.length === 0;
  };

  const handleInterviewSubmit = async e => {
    e.preventDefault(); // Prevent the default form submission behavior

    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    const startDateTimeString = `${moment(
      getCompanyTimezoneDateTime(int_start_time)
    ).format("YYYY-MM-DD")}T${selectedStartTime}`;
    const endDateTimeString = `${moment(
      getCompanyTimezoneDateTime(int_end_time)
    ).format("YYYY-MM-DD")}T${selectedEndTime}`;

    let ChangedEventDate = moment(
      getCompanyTimezoneDateTime(startDateTimeString)
    ).utc();
    let ChangedEndEventDate = moment(
      getCompanyTimezoneDateTime(endDateTimeString)
    ).utc();

    const dynamicApplId = selectedApplId;
    const user_id = selectedCandidate?.user_id || "";
    let newFormData = JSON.parse(JSON.stringify(formData));
    const formattedDate = convertDateFormat(ChangedEventDate);
    newFormData.int_schedule_date = formattedDate;
    newFormData.int_start_time = ChangedEventDate;
    newFormData.int_end_time = ChangedEndEventDate;
    newFormData.time_zone_id = userInfo?.company_time_zone_id;
    let device_info = await getDeviceInfo(navigator);
    newFormData = {
      ...newFormData,
      device_info: device_info,
      old_status:
        newFormData?.interview_title + " - " + newFormData?.roundStatus,
      new_status: newFormData?.interview_title + " - Scheduled",
    };
    try {
      await api.post(
        `${process.env.REACT_APP_API_URL}/admin/screening/schedule-interview/${dynamicApplId}/${user_id}`,
        newFormData
      );
      toast.success(t(`ATS View.Interview Scheduled successfully`));
      handleToggleForm();
      setAssessmentModal(false);
      clearDtTime();
    } catch (error) {
      console.error("Error submitting form:", error);
      setAssessmentModal(false);
      toast.error(t(`ATS View.Error submitting form`));
    }
  };

  // Interview Schedules functions

  // Function to update the state in the parent component errors
  const handleErrorsValueChange = errors => {
    // Parse the JSON string into an object
    setErrorsTimeslots(errors);
  };

  const handleTimeslotSubmit = event => {
    event.preventDefault();

    setErrors({});
    let errorObj = {};
    const errorMessages = [];

    let payload = new FormData();

    const mappedTimeSlots = Object.fromEntries(
      Object.entries(daytimeSlots)
        .map(([day, slots]) => {
          const integerKey = dayToIntegerMap[day];
          if (integerKey === undefined) return;
          return [integerKey, slots];
        })
        .filter(entry => entry !== undefined)
    );

    const timeSlotsobj = JSON.stringify(mappedTimeSlots, null, 2);

    payload.append("timeSlots", timeSlotsobj);

    // Log the FormData contents
    payload.forEach((value, key) => {});

    // Loop through each day in the ErrorsTimeslots object and extract the messages
    for (const [day, messages] of Object.entries(ErrorsTimeslots)) {
      // Check if the day contains any messages
      if (Array.isArray(messages) && messages.length > 0) {
        errorObj[day] = messages; // Keep track of errors per day
        // Push all non-empty error messages for the day into errorMessages
        messages.forEach(message => {
          if (message && message.trim() !== "") {
            // Check if message is not empty or only whitespace
            errorMessages.push(`${day}: ${message}`);
          }
        });
      } else {
        // If no messages, remove the day from ErrorsTimeslots
        delete ErrorsTimeslots[day];
      }
    }

    // Display the error messages, for example using toast
    if (errorMessages.length > 0) {
      toast.error(errorMessages.join("\n")); // Display each error on a new line
      setErrors(errorObj); // Set the error state for the form
      setIsLoading(false);
    } else {
      // Proceed to call the API if the payload is correct
      updateUserTimeslots(payload);
    }
  };

  // Function to update user
  const updateUserTimeslots = payload => {
    const userId = formData?.interviewer_time || 0;
    if (!userId || userId === "0") {
      return; // Exit the function if userId is invalid
    }

    api
      .patch(
        `${process.env.REACT_APP_API_URL}/admin/user/update-usertimeslots/${userId}`,
        payload,
      )
      .then(response => {
        setIsLoading(false);
        setShowTimeslotBooking(false); // Hide TimeslotBookingAdmin after success
        clearDtTime();

        // Show success toast
        toast.success(t(`ATS View.Timeslots updated successfully!`));
      })
      .catch(err => {
        setIsLoading(false);
        console.log("Error:", err);

        // Show error toast (optional)
        toast.error(t(`ATS View.Failed to update timeslots`));
      });
  };

  // Fetch time slots based on interviewerID
  const fetchInterTimeslot = async (interviewer_id, date, type) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/user/fetch-timeslots/${interviewer_id}?date=${date}`,
      );

      const result = response.data;
      const { user } = result;
      const { timeSlots, bookedTimeSlots, timeSlotsData } = user;
      settimeSlotsData(timeSlotsData || {});
      if (Array.isArray(timeSlots)) {
        if (type === "start") {
          // Extract start times for the start time dropdown
          const startTimes = timeSlots.map(slot => slot.startTime);
          setsDateTimeSlots(startTimes); // Update start time slots state
        } else if (type === "end") {
          // Filter end times based on the selected start time
          const filteredTimeSlots = timeSlots.filter(slot =>
            moment(slot.startTime, "HH:mm").isSameOrAfter(
              moment(selectedStartTime, "HH:mm")
            )
          );

          if (filteredTimeSlots?.length > 0) {
            const endTimes = filteredTimeSlots.map(slot => slot.endTime);
            seteDateTimeSlots(endTimes); // Update end time slots state
          } else {
            seteDateTimeSlots([]); // No available end time slots
            toast.error(t(`ATS View.No available end time slots`));
          }
        }
      } else {
        console.error("timeSlots is not an array:", timeSlots);
      }
    } catch (error) {
      console.error("Error fetching time slots:", error);
    }
  };

  const clearDtTime = () => {
    setsDateTimeSlots([]);
    seteDateTimeSlots([]);
    setStartTime("");
    setEndTime("");
    setSelectedStartTime("");
    setSelectedEndTime("");
    setIsTimeslotBtnDisabled(true);
  };

  const handleDateChange = (date, type) => {
    let valid = true;
    const formattedDate = moment(getCompanyTimezoneDateTime(date)).format(
      "YYYY-MM-DD"
    );
    if (formData?.interviewer_time === "0") {
      clearDtTime();
      toast.error(t(`ATS View.Please select a Interviewer`));
      return false;
    }

    if (type === "start") {
      setSelectedStartTime("");
      setSelectedEndTime("");
      setEndTime("");
      setStartTime(formattedDate); // Update the start date
    } else if (type === "end") {
      setSelectedEndTime("");
      // Check if start date and start time are set before setting the end time
      if (!int_start_time) {
        toast.error(t(`ATS View.Please select a start date`));
        return false;
      }
      if (!selectedStartTime) {
        toast.error(t(`ATS View.Please select a start time`));
        return false;
      }
      setEndTime(formattedDate); // Set end date
    }
    const interviewerID = formData?.interviewer_time || 0;
    fetchInterTimeslot(interviewerID, formattedDate, type);
    // Enable button if interviewer_time is greater than zero
    setIsTimeslotBtnDisabled(interviewerID <= 0);
  };

  // Handle start time selection
  const handleStartTimeChange = time => {
    const selectedDate = new Date(int_start_time); // Date selected in DatePicker
    const [hours, minutes] = time.split(":");

    // Clone the selected date and set the selected time
    const selectedTime = new Date(selectedDate);
    selectedTime.setHours(hours);
    selectedTime.setMinutes(minutes);

    const currentDateTime = new Date(); // Get current date and time

    // Check if the selected start date is today
    const isToday =
      selectedDate.toDateString() === currentDateTime.toDateString();

    // Only perform the "must be in the future" validation if today is selected
    if (isToday && selectedTime <= currentDateTime) {
      // Set an error if the selected time is invalid and today is selected
      setErrors(prevErrors => ({
        ...prevErrors,
        selectedStartTime: t(`ATS View.Selected time must be in the future`),
      }));
    } else {
      // Clear the error if the time is valid or if the date is not today
      setErrors(prevErrors => ({
        ...prevErrors,
        selectedStartTime: "", // Clear the specific error for the start time
      }));

      // Update the state for selected time and reset end time slots
      setSelectedStartTime(time);
      seteDateTimeSlots([]); // Reset end time slots
      setEndTime(""); // Reset end time
      setSelectedEndTime(""); // Reset selected end time
    }
  };

  const handleEndTimeChange = e => {
    const selectedEnd = e.target.value;
    setSelectedEndTime(selectedEnd);

    if (selectedStartTime) {
      // Helper function to parse time
      const parseTime = time => {
        const [hours, minutes] = time.split(":").map(Number);
        const today = new Date();
        return new Date(today.setHours(hours, minutes, 0, 0)); // Set time to today's date
      };

      const startTime = parseTime(selectedStartTime);
      const endTime = parseTime(selectedEnd);
      const now = new Date(); // Current date and time

      // Check if the selected start date is today
      const selectedDate = new Date(int_start_time); // Assuming int_start_time is the selected start date
      const isToday = selectedDate.toDateString() === now.toDateString();

      // Validation: End time cannot be in the past or present only if today is selected
      if (isToday && endTime <= now) {
        setSelectedEndTime("");
        toast.error(
          t(`ATS View.End time cannot be in the past or the present`)
        );
        return;
      }

      // Validation: End time must be after the selected start time
      if (endTime <= startTime) {
        setSelectedEndTime("");
        toast.error(t(`ATS View.End time must be after the start time`));
        return;
      }

      // Check for overlap with booked time slots
      const hasOverlap = bookedTimeSlots.some(slot => {
        const bookedStart = parseTime(slot.startTime);
        const bookedEnd = parseTime(slot.endTime);

        return startTime < bookedEnd && endTime > bookedStart;
      });

      if (hasOverlap) {
        setSelectedEndTime("");
        toast.error(
          t(`ATS View.Selected time overlaps with an existing booking`)
        );
        return;
      }

      // If validation passes, update formData
      setFormData(prevFormData => ({
        ...prevFormData,
        int_schedule_time: `${selectedStartTime} - ${selectedEnd}`,
      }));
    }
  };

  const handleAddTimeslotsClick = e => {
    e.preventDefault(); // Prevent the default form submission behavior
    setShowTimeslotBooking(true); // Show TimeslotBookingAdmin when the button is clicked
  };

  const handleCancelClick = e => {
    e.preventDefault(); // Prevent default behavior
    setShowTimeslotBooking(false); // Hide TimeslotBookingAdmin
  };

  const handleChildValueChange = value => {
    // Parse the JSON string into an object
    const jsonObject = JSON.parse(value);
    setDaytimeSlots(jsonObject);
  };

  const open_slider = async (appl_id, status, round_id) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/common/fetch-details/${appl_id}`
      );
      const data = response.data;

      if (data?.status && data?.data?.length > 0) {
        setCandidateDetails({
          ...data?.data?.[0],
          round_id: round_id,
        });
      } else {
        console.error("Invalid data format received from API:", data);
      }
    } catch (error) {
      console.error("Error fetching candidate details:", error);
    }
    if (status == 1) {
    
    } else if (status == 2) {
      setIsReject(!isReject);
    } else if (status == 3) {
      setisSelected(!isVisibles);
    } else if (status == 8) {
      // handleCloseAssessmentModal();
      setIsFeedback(!isFeedback);
    }
  };

  const feedback_close = () => {
    setIsFeedback(false);
  };

  const handlefeedback = async (appl_id, status) => {
    await createfeedback(
      appl_id,
      status,
      comment,
      categoryRatings,
      candidateDetails?.round_id
    ).then(res => {
      if (res?.status === 200) {
        toast.success(t(`ATS View.Feedback Added successfully`));
      } else {
        toast.error(res?.data?.message);
      }
    });
    feedback_close();
    await fetchRoundsData({ appl_id: selectedApplId });
  };

  const handleChange = e => {
    setComment(e.target.value);
    setCommentError("");
  };

  const handleChangeRating = (category, rating) => {
    setCategoryRatings(prevRatings => ({
      ...prevRatings,
      [category]: rating,
    }));
  };

  useEffect(() => {
    // Add the class to the body
    document.body.classList.add("job-posting-body");

    // Cleanup: Remove the class when the component unmounts
    return () => {
      document.body.classList.remove("job-posting-body");
    };
  }, ["job-posting-body"]);

  console.log(selectedCandidates, "selectedCandidates");

  const getAssesmentLink = async (
    round_id,
    appl_id,
    user_id,
    vacancy_id,
    status
  ) => {
    try {
      let authUser = JSON.parse(localStorage.getItem("authUser"));
      let adminId = authUser.user.id;
      let interviewerexam = 1;
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/admin/pending/getAssesmentLink`,
        {
          round_id,
          appl_id: selectedCandidate?.appl_id || "",
          user_id,
          vacancy_id,
          status,
          adminId,
          interviewerexam,
        },
      );
      if (response?.status === 200) {
        window.open(`${response?.data?.Url}`, "_blank");
      } else {
        toast.error(t(`all-application.Send link fail`));
      }
      // handleCloseAssessmentModal();
    } catch (error) {
      toast.error("Error: " + error.message);
    }
  };
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  const selected_close = () => {
    setisSelected(false);
  };
  const validateComments = () => {
    console.log(comments, "comments");
    if (!comments.trim()) {
      setCommentsError(t(`all-application.Comment required`));
      return false;
    }
    // You can add more validation rules here if needed
    return true;
  };
  const handleSelected = async (appl_id, user_id) => {
    if (!offerLetter) {
      // setOfferLetterError("Offer letter is required");
      toast.error("Offer letter is required");
      return;
    }

    if (validateComments()) {
      let formData = new FormData();
      let device_info = await getDeviceInfo(navigator);
      formData.append("offer_letter", offerLetter);
      formData.append("ctc_offered", ctcOffered);
      formData.append("comments", comments);
      formData.append("status_change_from", "2");
      formData.append("status", "3");
      formData.append("user_id", user_id);
      formData.append("old_status", "In Progress Applications");
      formData.append("new_status", "Selected Applications");
      formData.append("device_info", JSON.stringify(device_info));
      updateselected(appl_id, formData)
        .then(res => {
          if (res.status === 200) {
            setLoading(false);
            fetchJobDetails();
            setSelectedCandidates([]);
            toast.success("Offer letter sent Successfully.");
          } else {
            toast.error(res?.data?.message);
          }
          // FetchScreeningList()
          // window.location.reload();
        })
        .catch(error => {
          console.log(error);
        });
      selected_close();
    } else {
      console.log("Validation error:", commentError);
    }
  };

  console.log(JSON.stringify(candidateDetails), "candidateDetails");

  return (
    <>
      <div className="jobposting-section">
        <Container className="mw-100">
          <div className="joblist-container create-vacancy">
            <Row>
              <Col lg={12}>
                <div className="jobposting-title">
                  <div className="jobpost-card">
                    {/* <p className="m-0">
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/job-list");
                      }}
                    >
                      <img src="../img/arrow.svg" alt="" />
                    </span>
                    Job Posting
                  </p> */}

                    <ul className="job-list-primary pb-3">
                      <li>
                        <Link to="/job-list">
                          <h5 className="text-uppercase heading-one">
                            <img src={arrow_btn} alt="arrow_btn" />
                            {t(`ATS View.Application Tracking`)}
                          </h5>
                        </Link>
                      </li>
                      {/* <li>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                          >
                            {roundStatusName}{" "}
                            <img src="../img/arrow.svg" alt="" />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setRoundStatus("");
                                setRoundStatusName("All Status");
                              }}
                            >
                              Select Status
                            </Dropdown.Item>
                            {roundTypes?.map(el => (
                              <Dropdown.Item
                                key={el.value}
                                onClick={() => {ge
                                  setRoundStatus(el.value);
                                  setRoundStatusName(el.label);
                                }}
                              >
                                {el.label}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </li> */}
                    </ul>

                    <Dropdown className="pt-2 drodpdown-heading">
                      <Dropdown.Toggle variant="info" id="dropdown-basic">
                        <h1>
                          {jobDetails?.jobDetails?.title}{" "}
                          <img src="../img/arrow.svg" alt="Arrow Icon" />
                        </h1>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {data.map(elem => {
                          return (
                            <Dropdown.ItemText key={elem.id}>
                              <Link
                                to={`/job-posting/${elem.id}`}
                                onClick={() => {
                                  clearFilters();
                                  setRoundStatus("");
                                  setRoundStatusName(t(`ATS View.All Status`));
                                  setSelectedCandidates([]);
                                }}
                              >
                                {elem?.title}
                              </Link>
                            </Dropdown.ItemText>
                          );
                        })}
                      </Dropdown.Menu>
                      {jobDetails?.jobDetails?.status === 1 && (
                        <Button
                          variant="outline-primary"
                          className="mx-2"
                          size="sm"
                        >
                          {t(`ATS View.Live`)}
                        </Button>
                      )}
                    </Dropdown>
                  </div>
                  <div className="jobposting-list">
                    <SearchBar
                      onSearch={handleSubmit}
                      title={t(`all-application.Search by mobile2`)}
                      placeholder={
                        t(`all-application.Search by mobile`).slice(0, 40) +
                        "..."
                      }
                      query={query}
                      setQuery={setQuery}
                    />
                    <div
                      className="take-text filter"
                      onClick={() => toggleFilterModal()}
                    >
                      <h5>
                        <span>
                          <img src={filtericon} alt="" />
                        </span>
                        {t(`ATS View.Filters`)}
                      </h5>
                    </div>

                    <div className="take-text filter">
                      <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          {roundStatusName}{" "}
                          <img src="../img/arrow.svg" alt="" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              setRoundStatus("");
                              setRoundStatusName(t(`ATS View.All Status`));
                            }}
                          >
                            {t(`ATS View.Select Status`)}
                          </Dropdown.Item>
                          {roundTypes?.map(el => (
                            <Dropdown.Item
                              key={el.value}
                              onClick={() => {
                                setRoundStatus(el.value);
                                setRoundStatusName(el.label);
                              }}
                            >
                              {el.label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
                <div className="jobposting-title pt-3">
                  <ul>
                    {getSubdomain() !== "mahindra" && (
                      <li>
                        <img src={location} alt="location" />
                        <span>
                          {jobDetails?.jobDetails?.mode_of_job === "Remote"
                            ? "Onsite Remote"
                            : jobDetails?.jobDetails?.cities}
                        </span>
                      </li>
                    )}

                    <li>
                      <img src={years} alt="years" />
                      <span>{jobDetails?.jobDetails?.experience}</span>
                    </li>
                    <li>
                      <img src={level} alt="level" />
                      <span>{jobDetails?.jobDetails?.qualification}</span>
                    </li>
                    <li>
                      <img src={month} alt="month" />
                      <span>{jobDetails?.jobDetails?.expected_time}</span>
                    </li>
                    <li>
                      <img src={calender} alt="calender" />
                      <span>
                        {moment(
                          getCompanyTimezoneDateTime(
                            jobDetails?.jobDetails?.createdAt
                          )
                        ).format("Do MMM,YYYY")}
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="mt-3">
                  {getFilterList()?.length > 0 && (
                    <div className="selected-data-card length-selected-data  mb-4">
                      {getFilterList()?.map((el, index) => {
                        return (
                          <div className="select-para" key={index}>
                            <p>
                              <span className="selected-tag text-capitalize">
                                {el?.label} - {el?.value}
                              </span>
                              <button
                                className="remove-tag-button"
                                onClick={() => handleFilterRemove(el?.key)}
                              >
                                &times;
                              </button>
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>

          <div className="outerTab-box-wrapper below-vacancy">
            <Row>
              {filterModal && (
                <div className="filter-shadow jobposting-card filetrcards">
                  <div className="filters-cards">
                    <div className="filters-cards-cross file-cards">
                      <div className="filter-content">
                        <h4>{t(`ATS View.Filters`)}</h4>
                      </div>
                      <div
                        className="filter-content cross"
                        onClick={() => toggleFilterModal()}
                      >
                        <img src={cross} alt="" />
                      </div>
                    </div>
                    <div className="bordertops"></div>

                    {/* <div className="application-gender">
                      <h5>Relevancy Score</h5>
                      <div className="col-lg-12">
                        <Slider
                          range
                          min={minValue}
                          max={maxValue}
                          value={RelevancyScore}
                          onChange={value => {
                            setRelevancyScore(value);
                          }}
                        />
                        <p>
                          Relevancy Score: {RelevancyScore[0]} -{" "}
                          {RelevancyScore[1]}
                        </p>
                      </div>
                    </div> */}

                    {/* <div className="application-gender">
                      <h5>Behaviour Score</h5>
                      <div className="col-lg-12">
                        <Slider
                          range
                          min={minValueBehavScore}
                          max={maxValueBehavScore}
                          value={BehaviouralScore}
                          onChange={value => {
                            setBehaviouralScore(value);
                          }}
                        />
                        <p>
                          Behaviour Score: {BehaviouralScore[0]} -{" "}
                          {BehaviouralScore[1]}
                        </p>
                      </div>
                    </div> */}
                    {/*
                    <div className="application-gender">
                      <h5>Total Experience</h5>
                      <div className="col-lg-12">
                        <Slider
                          range
                          min={0}
                          max={40}
                          allowCross={false}
                          defaultValue={totalExperience}
                          value={totalExperience}
                          onChange={value => {
                            setTotalExperience(value);
                          }}
                        />
                        <p>
                          Experience: {totalExperience[0]} -{" "}
                          {totalExperience[1]}
                        </p>
                      </div>
                    </div> */}
                    {getSubdomain() !== "mahindra" && (
                      <div className="col-lg-12">
                        <label>{t(`ATS View.Select Preferred Location`)}</label>
                        <MultiSelect
                          options={cities}
                          value={filters?.preferred_location || []}
                          // shouldToggleOnHover={true}
                          onChange={e => {
                            setFilters({
                              ...filters,
                              preferred_location: e,
                            });
                          }}
                          labelledBy="Select Preferred Location"
                          placeholder={t(`ATS View.Select`)}
                          overrideStrings={{
                            selectSomeItems: t(
                              `ATS View.Select Preferred Location`
                            ),
                            allItemsAreSelected: t(
                              "ATS View.All items are selected"
                            ),
                            search: t("ATS View.Search"),
                            selectAll: t("ATS View.Select All"),
                          }}
                        />
                      </div>
                    )}

                    {getSubdomain() !== "mahindra" && (
                      <div className="col-lg-12 mb-3">
                        <label>{t(`ATS View.Select Source Type`)}</label>
                        <Select
                          id="source"
                          placeholder={t(`ATS View.Select Source`)}
                          name="source"
                          value={filters?.source}
                          options={sources}
                          onChange={e =>
                            setFilters({
                              ...filters,
                              source: e,
                            })
                          }
                        />
                      </div>
                    )}

                    {getSubdomain() !== "mahindra" && (
                      <div className="col-lg-12 mb-3">
                        <label>{t(`ATS View.Select State`)}</label>
                        <Select
                          id="state"
                          placeholder={t(`ATS View.Select State`)}
                          name="state"
                          value={filters?.state}
                          options={states}
                          onChange={e => handleStateChange(e)}
                        />
                      </div>
                    )}

                    {getSubdomain() !== "mahindra" && (
                      <div className="col-lg-12 mb-3">
                        <label>{t(`ATS View.Select City`)}</label>
                        <Select
                          id="city"
                          placeholder={t(`ATS View.Select City`)}
                          name="city"
                          value={filters?.city}
                          options={filteredCities}
                          onChange={e =>
                            setFilters({
                              ...filters,
                              city: e,
                            })
                          }
                        />
                      </div>
                    )}
                    {/* <div className="col-lg-12 mb-3">
                      <label>{t(`ATS View.Select Area`)}</label>
                      <Select
                        id="area"
                        placeholder={t(`ATS View.Select Area`)}
                        name="area"
                        value={filters?.area}
                        options={areas}
                        onChange={e =>
                          setFilters({
                            ...filters,
                            area: e,
                          })
                        }
                      />
                    </div> */}

                    <div className="col-lg-12 mb-3">
                      <label>
                        {t(`ATS View.Select Highest Qualification`)}
                      </label>
                      <Select
                        id="qualification"
                        placeholder={t(`ATS View.Select Qualification`)}
                        name="qualification"
                        value={filters?.qualification}
                        options={qualdropdown} // Pass directly
                        onChange={e =>
                          setFilters({
                            ...filters,
                            qualification: e,
                          })
                        }
                      />
                    </div>
                    {getSubdomain() !== "mahindra" && (
                      <div className="col-lg-12 ">
                        <label>{t(`ATS View.Select Tags`)}</label>
                        <Select
                          id="newtags"
                          placeholder={t(`ATS View.Select Tags`)}
                          name="newtags"
                          value={filters?.tags}
                          options={tags}
                          onChange={e =>
                            setFilters({
                              ...filters,
                              tags: e,
                            })
                          }
                        />
                      </div>
                    )}
                    <div className="application-gender">
                      <Col md={12}>
                        <Form.Group className="mb-3 floating-label">
                          <Form.Label className="float-label">
                            {t(`ATS View.Skills`)}
                          </Form.Label>
                          <MultiSelect
                            id="skills"
                            placeholder={t(`ATS View.Select Skills`)}
                            name="skills"
                            value={filters?.skills || []}
                            // isMulti
                            options={skillList || []}
                            onChange={e =>
                              setFilters({
                                ...filters,
                                skills: e,
                              })
                            }
                            overrideStrings={{
                              selectSomeItems: t(`ATS View.Select Skills`),
                              allItemsAreSelected: t(
                                "ATS View.All items are selected"
                              ),
                              search: t("ATS View.Search"),
                              selectAll: t("ATS View.Select All"),
                            }}
                          />
                        </Form.Group>
                      </Col>
                      {getSubdomain() !== "mahindra" && (
                        <>
                          <Col md={12}>
                            <Form.Group className="mb-3 floating-label">
                              <Form.Label className="float-label">
                                {t(`ATS View.Relevancy Score`)}
                              </Form.Label>
                              <RangeSlider
                                progress
                                min={0}
                                max={100}
                                className="dual-range mt-3"
                                value={filters?.relevancy_score}
                                onChange={value => {
                                  setFilters({
                                    ...filters,
                                    relevancy_score: value,
                                  });
                                }}
                              />
                              <div className="d-flex justify-content-between mt-1">
                                <div className="mx-1">0</div>
                                <div className="mx-1">100</div>
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className="mb-3 floating-label">
                              <Form.Label className="float-label">
                                {t(`ATS View.Behavioural Score`)}
                              </Form.Label>
                              <RangeSlider
                                progress
                                min={0}
                                max={100}
                                className="dual-range mt-3"
                                value={filters?.behavioural_score}
                                onChange={value => {
                                  setFilters({
                                    ...filters,
                                    behavioural_score: value,
                                  });
                                }}
                              />
                              <div className="d-flex justify-content-between mt-1">
                                <div className="mx-1">0</div>
                                <div className="mx-1">100</div>
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className="mb-3 floating-label">
                              <Form.Label className="float-label">
                                {t(`ATS View.Total Experience`)}
                              </Form.Label>
                              <RangeSlider
                                progress
                                min={0}
                                max={40}
                                className="dual-range mt-3"
                                value={filters?.total_experience}
                                onChange={value => {
                                  setFilters({
                                    ...filters,
                                    total_experience: value,
                                  });
                                }}
                              />
                              <div className="d-flex justify-content-between mt-1">
                                <div className="mx-1">0</div>
                                <div className="mx-1">40</div>
                              </div>
                            </Form.Group>
                          </Col>
                        </>
                      )}

                      <div className="col-lg-12 mb-3">
                        <label>{t(`ATS View.Start Date`)}</label>

                        <Form.Group
                          controlId="formStartDate"
                          className="input-formtext d-flex"
                        >
                          <DatePicker
                            selected={
                              filters?.start_date
                                ? new Date(filters?.start_date)
                                : ""
                            }
                            name="int_schedule_date"
                            onChange={date => {
                              setFilters({
                                ...filters,
                                start_date: date,
                              });
                            }}
                            className="form-control"
                            dateFormat="dd-MMM-yyyy"
                            placeholderText={t(`ATS View.Select Start Date`)}
                          />
                          {/* <span className="calender-icon ">
                            <img src={calender_icon} alt="" />
                          </span> */}
                        </Form.Group>
                      </div>

                      <div className="col-lg-12 mb-3">
                        <label>{t(`ATS View.End Date`)}</label>
                        <Form.Group
                          controlId="formEndDate"
                          className="input-formtext d-flex"
                        >
                          <DatePicker
                            selected={
                              filters?.end_date
                                ? new Date(filters?.end_date)
                                : ""
                            }
                            name="endDate"
                            onChange={date => {
                              setFilters({
                                ...filters,
                                end_date: date,
                              });
                            }}
                            className="form-control"
                            dateFormat="dd-MMM-yyyy"
                            placeholderText={t(`ATS View.Select End Date`)}
                          />
                          {/* <span className="calender-icon ">
                            <img src={calender_icon} alt="" />
                          </span> */}
                        </Form.Group>
                      </div>

                      {/* <div className="col-lg-12 mb-3">
                        <label>Auto-Rejected </label>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="autoRejectToggle"
                            checked={filters?.is_Auto_Rejected}
                            onChange={e => {
                              setFilters({
                                ...filters,
                                is_Auto_Rejected: e.target.checked,
                              });
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="autoRejectToggle"
                          >
                            {filters?.is_Auto_Rejected ? "Yes" : "No"}
                          </label>
                        </div>
                      </div> */}
                    </div>
                    {errors?.submitButton && (
                      <p className="text-danger">{errors?.submitButton}</p>
                    )}
                    <div className="col-lg-12">
                      <div className="serach-btn">
                        <button
                          className="btn btn-primary reset"
                          onClick={() => {
                            clearFilters();
                            setFilterModal(false);
                          }}
                        >
                          {t(`ATS View.Reset`)}
                        </button>
                        <button
                          className="btn btn-primary search"
                          onClick={e => handleSubmit(e)}
                        >
                          {t(`ATS View.Search`)}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="jobposting-card mb-4">
                {selectedCandidates?.length > 0 && (
                  <>
                    <div className="job-post-minicard jobcard w-100 d-flex justify-content-between flex-row align-items-center">
                      <div className="jov-fonts ob">
                        <FontAwesomeIcon
                          onClick={() => setSelectedCandidates([])}
                          icon={faRemove}
                          className="font-size-20"
                          style={{ cursor: "pointer" }}
                        />{" "}
                        <span className="mx-3 font-size-20">
                          {" "}
                          {selectedCandidates?.length || 0}{" "}
                          {t(`ATS View.Selected`)}
                        </span>
                      </div>
                      <div className="d-flex gap-3 jov-fonts">
                        <div className="select-class-job">
                          <Select
                            placeholder={t(`ATS View.Select Stage`)}
                            options={stageOptions}
                            onChange={e => {
                              if (
                                selectedCandidates.length > 1 &&
                                (e.value === "selected" ||
                                  e.value === "rejected" ||
                                  e.value === "inprogress")
                              ) {
                                toast.error(
                                  "You can select only one candidate."
                                );
                                setStageValue(""); // clear stage
                              } else {
                                setStageValue(e.value); // normal case
                              }
                            }}
                            value={stageOptions?.find(
                              el => el?.value === stageValue
                            )}
                          />
                        </div>
                        <Button onClick={() => handleMultiStatusApply()}>
                          {t(`ATS View.Apply`)}
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </div>
              {isSelected && (
                <div className="filter-shadow reject-people-data">
                  <div className="filters-cards">
                    <div className="filters-cards-cross">
                      <div className="filter-content">
                        <h4>{t(`all-application.Select Application`)}</h4>
                      </div>
                      <div
                        className="filter-content cross"
                        onClick={selected_close}
                      >
                        <img src={cross} alt="cross icon" />
                      </div>
                    </div>

                    <div class="bordertops"></div>
                    <div className="reject-people data justify-content-between">
                      <div className="mobile-cards">
                        <div className="reject-perople-user">
                          <img
                            src={
                              selectedCandidate?.candidate_photo || user_icons1
                            }
                            alt="user icon"
                            className={
                              selectedCandidate?.candidate_photo
                                ? "image-upload"
                                : "iconuse"
                            }
                          />
                        </div>
                        <div className="header-plant">
                          <h4> {candidateDetails.name}</h4>
                        </div>
                      </div>

                      <div className="reject-people-user-data">
                        <div className="header-plant ss">
                          <h4> {candidateDetails.name}</h4>
                          {Math.round(feedbackInfo?.averageScore * 10) / 10 >
                            0 && (
                            <span className="start-icons">
                              <FontAwesomeIcon
                                icon={faStar}
                                style={{ cursor: "pointer", color: "#FEAE44" }}
                              />
                              {Math.round(feedbackInfo?.averageScore * 10) / 10}
                            </span>
                          )}
                        </div>

                        <div className="reject-people-user-data-card">
                          <div className="people-biodata pb-0">
                            <div className="people-name">
                              <p>{t(`all-application.Job Role`)}</p>
                              <h4> {candidateDetails?.vacancy?.title}</h4>
                            </div>
                          </div>

                          <div className="people-biodata pb-0">
                            <div className="people-name">
                              <p>{t(`all-application.Education`)}</p>
                              <h4>
                                {candidateDetails?.master_reference_table
                                  ?.highest_qualification ||
                                  candidateDetails?.highest_qualification}
                              </h4>
                            </div>
                          </div>

                          <div className="people-biodata pb-0">
                            <div className="people-name">
                              <p>{t(`all-application.Total Exp`)}.</p>
                              <h4>
                                {(candidateDetails?.job_user
                                  ?.total_experience || 0) +
                                  " " +
                                  t("Edit Job.years")}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="filter-cards-form reject-data">
                      <h4 className="pt-1">
                        {t(`all-application.Select Candidate confirmation`)}
                      </h4>
                      {/* <p>{t(`all-application.Select Candidate msg`)}</p> */}
                      <form class="form-inline pt-2">
                        <div className="col-lg-12">
                          <Form.Group>
                            <textarea
                              class="form-control"
                              id="exampleFormControlTextarea1"
                              placeholder={t(`all-application.Comment`)}
                              rows="3"
                              onChange={e => setComments(e.target.value)}
                            ></textarea>
                            {commentsError && (
                              <div className="text-danger">{commentsError}</div>
                            )}
                          </Form.Group>
                        </div>

                        <div className="col-lg-12 pt-3">
                          <Form.Group>
                            <Form.Label>
                              {t(`all-application.Upload Offer`)}
                            </Form.Label>
                            <AvForm>
                              <AvField
                                type="file"
                                className="form-control"
                                id="offer_letter"
                                name="offer_letter"
                                errorMessage="Offer letter is required"
                                placeholder=" "
                                accept=".pdf, .doc, .docx"
                                onChange={e =>
                                  setOfferLetter(e.target.files[0])
                                }
                                validate={{ required: { value: true } }}
                              />
                            </AvForm>
                          </Form.Group>
                        </div>
                        {/* <p>CTC Offered To Candidate</p> */}
                        <div className="col-lg-12 pt-3">
                          <Form.Group>
                            <Form.Label className="float-label">
                              {t(`all-application.CTC Offered`)}
                            </Form.Label>

                            <Form.Control
                              type="number"
                              placeholder={t(
                                `all-application.Enter CTC Offered`
                              )}
                              name="ctc_offered"
                              onChange={e => setCtcOffered(e.target.value)}
                              validate={{ required: { value: true } }}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-lg-12">
                          <div className="serach-btn">
                            <a
                              href="javascript:void(0);"
                              id="next"
                              class="nxt_prev_ques btn btn-primary btn-lg next-btn"
                              onClick={() =>
                                handleSelected(
                                  candidateDetails.appl_id,
                                  candidateDetails.user_id
                                )
                              }
                            >
                              {t(`all-application.Select`)}
                            </a>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="black-showd"></div>
                </div>
              )}
              {!loading && (
                <>
                  <div className="jobposting-card">
                    <Row
                      className="scroll-row"
                      ref={scrollRef}
                      onMouseDown={handleMouseDown}
                      onMouseMove={handleMouseMove}
                      onMouseUp={handleMouseUp}
                      onMouseLeave={handleMouseLeave}
                      // style={{
                      //   height: "500px",
                      //   maxHeight: "500px",
                      //   overflow: "auto",
                      // }}
                    >
                      {getSubdomain() === "mahindra" && (
                        <Col lg={3}>
                          <div className="new-application blue-card">
                            <h4 className="text-left ">
                              <div className="d-flex align-items-center mt-0  gap-2 w-100  new-applica-spl">
                                <div className="checkbox-bedge-card"></div>
                                <div>
                                  {t(`ATS View.pre_assessment_pplications`)}{" "}
                                  <span>
                                    (
                                    {filteredpreassessmentApplicants?.length ||
                                      0}
                                    )
                                  </span>
                                </div>
                              </div>

                              <div className=" dropdown-select-input w-100">
                                {checkSameStageSelected(
                                  "Pre assessment Applications",
                                  ""
                                ) &&
                                  jobDetails?.assessmentRounds && (
                                    <Select
                                      id="roundStatus"
                                      placeholder={t(
                                        `ATS View.Select Round Status`
                                      )}
                                      name="roundStatus"
                                      options={[
                                        {
                                          label: t(
                                            `ATS View.Move to Next Round`
                                          ),
                                          value: "nextRound",
                                        },
                                        {
                                          label: t(
                                            `ATS View.Send Assessment Link`
                                          ),
                                          value: "assessment",
                                          disabled:
                                            !jobDetails?.jobDetails
                                              ?.isStartRoundTest,
                                        },
                                      ]}
                                      onChange={e =>
                                        hanldeBulkRoundStatusChange(e, {
                                          id: jobDetails?.assessmentRounds?.[0]
                                            ?.id,
                                        })
                                      }
                                      isOptionDisabled={option =>
                                        option?.disabled
                                      }
                                    />
                                  )}
                              </div>
                            </h4>

                            <div className="job-list-app">
                              {filteredpreassessmentApplicants?.map(el => {
                                return (
                                  <div
                                    key={el?.appl_id}
                                    className="job-post-minicard"
                                  >
                                    <h5 className="text-capitalize d-flex align-items-center justify-content-between">
                                      <div className="d-flex align-items-center gap-2">
                                        <div className="checkbox-bedge-card"></div>
                                        <span
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            history.push(
                                              `/candidate_consolidate/view-details/${el?.appl_id}`
                                            );
                                          }}
                                        >
                                          {el?.name || ""}
                                        </span>
                                      </div>
                                      <div className="checkbox-bedge-card">
                                        {el?.jobSkills?.length > 0 && (
                                          <div className="checkbox-bedge-html">
                                            <span>
                                              <img src={html_bedge} alt="" />
                                            </span>
                                            {el?.jobSkills?.[0]?.name}{" "}
                                            {el?.jobSkills?.length - 1}+
                                          </div>
                                        )}
                                      </div>
                                    </h5>

                                    <div className="applied-job">
                                      <div className="applied-card-text  auto-screening">
                                        <span>
                                          <img src={applieds} alt="applied" />
                                        </span>
                                        <p>
                                          {" "}
                                          {t(`ATS View.preassessment_tag`)}
                                        </p>
                                      </div>

                                      <div className="date-card applied-card-text">
                                        <span>
                                          <img src={calendar} alt="applied" />
                                        </span>
                                        <h6>
                                          {el?.status_updatedAt
                                            ? moment(
                                                getCompanyTimezoneDateTime(
                                                  el?.status_updatedAt
                                                )
                                              ).format("Do MMM,YYYY")
                                            : "N.A."}
                                        </h6>
                                      </div>
                                    </div>

                                    <div className="applied-job">
                                      <ul>
                                        {getSubdomain() !== "mahindra" && (
                                          <li>
                                            <div className="behavirour-score">
                                              <p>
                                                {t(
                                                  `ATS View.Behavioural Score`
                                                )}{" "}
                                                {el?.behavioural_score}%{" "}
                                              </p>
                                            </div>
                                          </li>
                                        )}
                                        <li>
                                          <div
                                            className={
                                              parseInt(el?.relevancy_score) < 50
                                                ? "text-danger low-match" // Low score (red)
                                                : parseInt(
                                                    el?.relevancy_score
                                                  ) >= 50 &&
                                                  parseInt(
                                                    el?.relevancy_score
                                                  ) < 76
                                                ? "text-warning  medium-match" // Medium score (yellow)
                                                : "text-success  high-match" // High score (green)
                                            }
                                          >
                                            <p>
                                              {el?.relevancy_score}%{" "}
                                              {parseInt(el?.relevancy_score) <
                                              50
                                                ? t(`ATS View.Low Match`)
                                                : parseInt(
                                                    el?.relevancy_score
                                                  ) >= 50 &&
                                                  parseInt(
                                                    el?.relevancy_score
                                                  ) < 76
                                                ? t(`ATS View.Medium Match`)
                                                : t(`ATS View.High Match`)}
                                            </p>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>

                                    <div className="text-muted mathc-card d-flex justify-content-between">
                                      <div className="assesment-centre-btn">
                                        <Link
                                          to="#"
                                          className="assesment-centre-btn1 btn btn-primary"
                                          onClick={() => {
                                            handleAssessmentStart(
                                              el?.vacancyId,
                                              el?.user_id,
                                              el?.appl_id,
                                              el?.name,
                                              jobDetails?.jobDetails?.title,
                                              el?.apply_date,
                                              el
                                            );
                                          }}
                                          title={t(
                                            `ATS View.Open Assessment Center`
                                          )}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <span>
                                            <img src={eyes_icon} alt="eyes" />
                                          </span>
                                          {t(`ATS View.Assessment Center`)}
                                        </Link>
                                      </div>

                                      <div className="assesment-centre-btn">
                                        <Link
                                          to="#"
                                          className="assesment-centre"
                                          onClick={() =>
                                            handleArchiveAppplication(el)
                                          }
                                          title={t(
                                            `ATS View.Archive Application`
                                          )}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <span>
                                            <img
                                              src={assessment_icon_img}
                                              alt="eyes"
                                            />
                                          </span>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </Col>
                      )}

                      <Col lg={3}>
                        <div className="new-application blue-card">
                          <h4 className="text-left ">
                            <div className="d-flex align-items-center mt-0  gap-2 w-100  new-applica-spl">
                              <div className="checkbox-bedge-card">
                                <div className="checkbox-bedge-card-input">
                                  <input
                                    type="checkbox"
                                    id="select-all-checkbox" // Unique id for the checkbox
                                    className="font-size-20 form-check-input"
                                    title={t(`ATS View.Select All`)}
                                    checked={isAllGroupSelected("pending")}
                                    onChange={e =>
                                      handleSelectCandidateMulti(
                                        e.target.checked,
                                        "pending"
                                      )
                                    }
                                    defaultChecked={false} // Use defaultChecked for checkboxes instead of defaultValue
                                  />
                                  <label
                                    htmlFor="select-all-checkbox"
                                    className="checkbox-label hide-class"
                                  >
                                    {t(`ATS View.Select All`)}
                                  </label>
                                </div>
                              </div>
                              <div>
                                {t(`ATS View.New Applications`)}{" "}
                                <span>
                                  ({filteredpendingApplicants?.length || 0})
                                </span>
                              </div>
                            </div>

                            <div className=" dropdown-select-input w-100">
                              {checkSameStageSelected("New Applications", "") &&
                                jobDetails?.assessmentRounds && (
                                  <Select
                                    id="roundStatus"
                                    placeholder={t(
                                      `ATS View.Select Round Status`
                                    )}
                                    name="roundStatus"
                                    options={[
                                      {
                                        label: t(`ATS View.Move to Next Round`),
                                        value: "nextRound",
                                      },
                                      {
                                        label: t(
                                          `ATS View.Send Assessment Link`
                                        ),
                                        value: "assessment",
                                        disabled:
                                          !jobDetails?.jobDetails
                                            ?.isStartRoundTest,
                                      },
                                    ]}
                                    onChange={e =>
                                      hanldeBulkRoundStatusChange(e, {
                                        id: jobDetails?.assessmentRounds?.[0]
                                          ?.id,
                                      })
                                    }
                                    isOptionDisabled={option =>
                                      option?.disabled
                                    }
                                    // menuIsOpen={isOpen} // Control open state
                                  />
                                )}
                            </div>
                          </h4>

                          <div className="job-list-app">
                            {filteredpendingApplicants?.map(el => {
                              return (
                                <div
                                  key={el?.appl_id}
                                  className="job-post-minicard"
                                >
                                  <h5 className="text-capitalize d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center gap-2">
                                      <div className="checkbox-bedge-card">
                                        <div className="checkbox-bedge-card-input">
                                          <input
                                            id={el?.appl_id} // Unique ID for the checkbox
                                            type="checkbox"
                                            onChange={e =>
                                              handleSelectCandidate(
                                                e.target.checked,
                                                el,
                                                "pending"
                                              )
                                            }
                                            checked={isCandidateSelected(el)}
                                          />
                                          <label
                                            htmlFor={el?.appl_id}
                                            className="checkbox-label hide-class"
                                          >
                                            {`Select candidate`}
                                          </label>
                                        </div>
                                      </div>
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          history.push(
                                            `/candidate_consolidate/view-details/${el?.appl_id}`
                                          );
                                        }}
                                      >
                                        {el?.name || ""}
                                      </span>
                                    </div>
                                    <div className="checkbox-bedge-card">
                                      {el?.jobSkills?.length > 0 && (
                                        <div className="checkbox-bedge-html">
                                          <span>
                                            <img src={html_bedge} alt="" />
                                          </span>
                                          {el?.jobSkills?.[0]?.name}{" "}
                                          {el?.jobSkills?.length - 1}+
                                        </div>
                                      )}
                                    </div>
                                  </h5>

                                  <div className="applied-job">
                                    <div className="applied-card-text  auto-screening">
                                      <span>
                                        <img src={applieds} alt="applied" />
                                      </span>
                                      <p> {t(`ATS View.Applied`)}</p>
                                    </div>

                                    <div className="date-card applied-card-text">
                                      <span>
                                        <img src={calendar} alt="applied" />
                                      </span>
                                      <h6>
                                        {el?.status_updatedAt
                                          ? moment(
                                              getCompanyTimezoneDateTime(
                                                el?.status_updatedAt
                                              )
                                            ).format("Do MMM,YYYY")
                                          : "N.A."}
                                      </h6>
                                    </div>
                                  </div>

                                  <div className="applied-job">
                                    <ul>
                                      {getSubdomain() !== "mahindra" && (
                                        <li>
                                          <div className="behavirour-score">
                                            <p>
                                              {t(`ATS View.Behavioural Score`)}{" "}
                                              {el?.behavioural_score}%{" "}
                                            </p>
                                          </div>
                                        </li>
                                      )}
                                      <li>
                                        <div
                                          className={
                                            parseInt(el?.relevancy_score) < 50
                                              ? "text-danger low-match" // Low score (red)
                                              : parseInt(el?.relevancy_score) >=
                                                  50 &&
                                                parseInt(el?.relevancy_score) <
                                                  76
                                              ? "text-warning  medium-match" // Medium score (yellow)
                                              : "text-success  high-match" // High score (green)
                                          }
                                        >
                                          <p>
                                            {el?.relevancy_score}%{" "}
                                            {parseInt(el?.relevancy_score) < 50
                                              ? t(`ATS View.Low Match`)
                                              : parseInt(el?.relevancy_score) >=
                                                  50 &&
                                                parseInt(el?.relevancy_score) <
                                                  76
                                              ? t(`ATS View.Medium Match`)
                                              : t(`ATS View.High Match`)}
                                          </p>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                  {getSubdomain() === "mahindra" && (
                                    <div className="applied-job">
                                      <ul>
                                        <li>
                                          <div className="behavirour-score">
                                            <p>
                                              {t(
                                                `ATS View.Pre_Assessment_Score`
                                              )}{" "}
                                              {el?.assessment_score}%{" "}
                                            </p>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  )}
                                  <div className="text-muted mathc-card d-flex justify-content-between">
                                    <div className="assesment-centre-btn">
                                      <Link
                                        to="#"
                                        className="assesment-centre-btn1 btn btn-primary"
                                        onClick={() => {
                                          handleAssessmentStart(
                                            el?.vacancyId,
                                            el?.user_id,
                                            el?.appl_id,
                                            el?.name,
                                            jobDetails?.jobDetails?.title,
                                            el?.apply_date,
                                            el
                                          );
                                        }}
                                        title={t(
                                          `ATS View.Open Assessment Center`
                                        )}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <span>
                                          <img src={eyes_icon} alt="eyes" />
                                        </span>
                                        {t(`ATS View.Assessment Center`)}
                                      </Link>
                                    </div>

                                    <div className="assesment-centre-btn">
                                      <Link
                                        to="#"
                                        className="assesment-centre"
                                        onClick={() =>
                                          handleArchiveAppplication(el)
                                        }
                                        title={t(
                                          `ATS View.Archive Application`
                                        )}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <span>
                                          <img
                                            src={assessment_icon_img}
                                            alt="eyes"
                                          />
                                        </span>
                                      </Link>
                                    </div>
                                  </div>

                                  {/* <div className="text-muted mathc-card d-flex justify-content-between">
                                    <div className="d-flex align-items-center gap-2">
                                      <h6>
                                        <span
                                          className={
                                            parseInt(el?.relevancy_score) < 50
                                              ? "text-danger"
                                              : parseInt(el?.relevancy_score) >
                                                  50 &&
                                                parseInt(el?.relevancy_score) <
                                                  76
                                              ? "text-warning"
                                              : "text-success"
                                          }
                                        >
                                          {el?.relevancy_score} %
                                        </span>
                                      </h6>
                                      <span>Match</span>
                                    </div>
                                    <div className="handle-app d-flex gap-2">
                                      {checkPermissionStatus(
                                        "archive-list",
                                        "edit"
                                      ) && (
                                        // <FontAwesomeIcon
                                        //   onClick={() => {
                                        //     handleAssessmentStart(
                                        //       el?.vacancyId,
                                        //       el?.user_id,
                                        //       el?.appl_id,
                                        //       el?.name,
                                        //       jobDetails?.jobDetails?.title
                                        //     );
                                        //   }}
                                        //   title="Open Assessment Center"
                                        //   icon={faEdit}
                                        //   className="font-size-18"
                                        //   style={{ cursor: "pointer" }}
                                        // />

                                        <img
                                          src={edit_icon}
                                          onClick={() => {
                                            handleAssessmentStart(
                                              el?.vacancyId,
                                              el?.user_id,
                                              el?.appl_id,
                                              el?.name,
                                              jobDetails?.jobDetails?.title
                                            );
                                          }}
                                          title="Open Assessment Center"
                                          className="font-size-18"
                                          style={{ cursor: "pointer" }}
                                        />
                                      )}
                                      {checkPermissionStatus(
                                        "archive-list",
                                        "edit"
                                      ) && (
                                        // <FontAwesomeIcon
                                        //   onClick={() =>
                                        //     handleArchiveAppplication(el)
                                        //   }
                                        //   title="Archive Application"
                                        //   icon={faArchive}
                                        //   color="red"
                                        //   className="font-size-18"
                                        //   style={{ cursor: "pointer" }}
                                        // />

                                        <img
                                          src={delete_icon}
                                          onClick={() =>
                                            handleArchiveAppplication(el)
                                          }
                                          title="Archive Application"
                                          color="red"
                                          className="font-size-18"
                                          style={{ cursor: "pointer" }}
                                        />
                                      )}
                                    </div>
                                  </div> */}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </Col>

                      {filteredAssessmentRounds?.length > 0 &&
                        filteredAssessmentRounds?.map((item, index) => {
                          return (
                            <>
                              <Col lg={3}>
                                <div className="new-application purple-card">
                                  <h4 className="text-left">
                                    <div className="d-flex align-items-center mt-0 gap-2 w-100 new-applica-spl">
                                      <div className="checkbox-bedge-card">
                                        <div className="checkbox-bedge-card-input">
                                          <Input
                                            type="checkbox"
                                            id={`select-all-checkbox-${index}`}
                                            className="font-size-20"
                                            title={t(`ATS View.Select All`)}
                                            onChange={e =>
                                              handleSelectCandidateMulti(
                                                e.target.checked,
                                                "assessment"
                                              )
                                            }
                                            defaultChecked={false}
                                          />
                                          <label
                                            htmlFor={`select-all-checkbox-${index}`}
                                            className="checkbox-label hide-class"
                                          >
                                            {t(`ATS View.Select All`)}
                                          </label>
                                        </div>
                                      </div>
                                      <div>
                                        {item?.interview_title}{" "}
                                        <span>
                                          ({item?.applicantList?.length || 0})
                                        </span>
                                      </div>
                                    </div>

                                    <div className=" dropdown-select-input w-100">
                                      {checkSameStageSelected(
                                        item?.interview_title,
                                        "assessment"
                                      ) && (
                                        <div key={index} className="w-100">
                                          <Select
                                            id="roundStatus"
                                            placeholder={t(
                                              `ATS View.Select Round Status`
                                            )}
                                            name="roundStatus"
                                            options={[
                                              ...roundTypes,
                                              {
                                                label: t(
                                                  `ATS View.Send Assessment Link`
                                                ),
                                                value: "assessment",
                                                disabled:
                                                  item?.round_type !== "Test",
                                              },
                                            ]}
                                            onChange={e =>
                                              hanldeBulkRoundStatusChange(
                                                e,
                                                item
                                              )
                                            }
                                            isOptionDisabled={option =>
                                              option?.disabled
                                            }
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </h4>

                                  <div className="job-list-app">
                                    {item?.applicantList?.map(el => {
                                      return (
                                        <div
                                          key={el?.appl_id}
                                          className="job-post-minicard"
                                        >
                                          <h5 className="text-capitalize d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center gap-2">
                                              <div className="checkbox-bedge-card">
                                                <div className="checkbox-bedge-card-input">
                                                  <Input
                                                    type="checkbox"
                                                    id={`checkbox-${el?.appl_id}`}
                                                    onChange={e =>
                                                      handleSelectCandidate(
                                                        e.target.checked,
                                                        el,
                                                        "assessment"
                                                      )
                                                    }
                                                    checked={isCandidateSelected(
                                                      el
                                                    )}
                                                  />
                                                  <label
                                                    htmlFor={`checkbox-${el?.appl_id}`}
                                                    className="checkbox-label hide-class"
                                                  >
                                                    Select candidate{" "}
                                                    {el?.appl_id}{" "}
                                                    {/* You can customize this text */}
                                                  </label>
                                                </div>
                                              </div>
                                              <span
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                  history.push(
                                                    `/candidate_consolidate/view-details/${el?.appl_id}`
                                                  );
                                                }}
                                              >
                                                {el?.name || ""}
                                              </span>
                                            </div>
                                            <div className="checkbox-bedge-card">
                                              {el?.jobSkills?.length > 0 && (
                                                <div className="checkbox-bedge-html">
                                                  <span>
                                                    <img
                                                      src={html_bedge}
                                                      alt=""
                                                    />
                                                  </span>
                                                  {el?.jobSkills?.[0]?.name}{" "}
                                                  {el?.jobSkills?.length - 1}+
                                                </div>
                                              )}
                                            </div>
                                          </h5>

                                          <div className="applied-job">
                                            <div className="applied-card-text  auto-screening">
                                              <span>
                                                <img
                                                  src={applieds}
                                                  alt="applied"
                                                />
                                              </span>
                                              <p>{el?.roundStatus}</p>
                                            </div>

                                            <div className="date-card applied-card-text">
                                              <span>
                                                <img
                                                  src={calendar}
                                                  alt="applied"
                                                />
                                              </span>
                                              <h6>
                                                {el?.status_updatedAt
                                                  ? moment(
                                                      getCompanyTimezoneDateTime(
                                                        el?.status_updatedAt
                                                      )
                                                    ).format("Do MMM,YYYY")
                                                  : "N.A."}
                                              </h6>
                                            </div>
                                          </div>

                                          <div className="applied-job">
                                            <ul>
                                              <li>
                                                <div className="rating-schedule">
                                                  <span>
                                                    <img src={star} alt="" />
                                                  </span>
                                                  {el?.feedbackScore}
                                                </div>
                                              </li>

                                              <li>
                                                <div className="behavirour-score">
                                                  <p>
                                                    {t(
                                                      `ATS View.Behavioural Score`
                                                    )}{" "}
                                                    {el?.behavioural_score}%{" "}
                                                  </p>
                                                </div>
                                              </li>

                                              <li>
                                                <div
                                                  className={
                                                    parseInt(
                                                      el?.relevancy_score
                                                    ) < 50
                                                      ? "text-danger low-match" // Low score (red)
                                                      : parseInt(
                                                          el?.relevancy_score
                                                        ) >= 50 &&
                                                        parseInt(
                                                          el?.relevancy_score
                                                        ) < 76
                                                      ? "text-warning  medium-match" // Medium score (yellow)
                                                      : "text-success  high-match" // High score (green)
                                                  }
                                                >
                                                  <p>
                                                    {el?.relevancy_score}%{" "}
                                                    {parseInt(
                                                      el?.relevancy_score
                                                    ) < 50
                                                      ? t(`ATS View.Low Match`)
                                                      : parseInt(
                                                          el?.relevancy_score
                                                        ) >= 50 &&
                                                        parseInt(
                                                          el?.relevancy_score
                                                        ) < 76
                                                      ? t(
                                                          `ATS View.Medium Match`
                                                        )
                                                      : t(
                                                          `ATS View.High Match`
                                                        )}
                                                  </p>
                                                </div>
                                              </li>
                                            </ul>
                                          </div>

                                          <div className="text-muted mathc-card d-flex justify-content-between">
                                            <div className="assesment-centre-btn">
                                              <Link
                                                to="#"
                                                className="assesment-centre-btn1 btn btn-primary"
                                                onClick={() => {
                                                  handleAssessmentStart(
                                                    el?.vacancyId,
                                                    el?.user_id,
                                                    el?.appl_id,
                                                    el?.name,
                                                    jobDetails?.jobDetails
                                                      ?.title,
                                                    el?.apply_date,
                                                    el
                                                  );
                                                }}
                                                title={t(
                                                  `ATS View.Open Assessment Center`
                                                )}
                                                style={{ cursor: "pointer" }}
                                              >
                                                <span>
                                                  <img
                                                    src={eyes_icon}
                                                    alt="eyes"
                                                  />
                                                </span>
                                                {t(
                                                  `ATS View.Assessment Center`
                                                )}
                                              </Link>
                                            </div>

                                            <div className="assesment-centre-btn">
                                              <Link
                                                to="#"
                                                className="assesment-centre"
                                                onClick={() =>
                                                  handleArchiveAppplication(el)
                                                }
                                                title={t(
                                                  `ATS View.Archive Application`
                                                )}
                                                color="red"
                                                style={{ cursor: "pointer" }}
                                              >
                                                <span>
                                                  <img
                                                    src={assessment_icon_img}
                                                    alt="eyes"
                                                  />
                                                </span>
                                              </Link>
                                            </div>
                                          </div>

                                          {/* <div className="text-muted mathc-card d-flex justify-content-between">
                                            <div className="d-flex align-items-center gap-2">
                                              <h6>
                                                <span
                                                  className={
                                                    parseInt(
                                                      el?.relevancy_score
                                                    ) < 50
                                                      ? "text-danger"
                                                      : parseInt(
                                                          el?.relevancy_score
                                                        ) > 50 &&
                                                        parseInt(
                                                          el?.relevancy_score
                                                        ) < 76
                                                      ? "text-warning"
                                                      : "text-success"
                                                  }
                                                >
                                                  {el?.relevancy_score} %
                                                </span>
                                              </h6>
                                              <span>Match</span>
                                            </div>
                                            <div className="handle-app d-flex gap-3">
                                              {checkPermissionStatus(
                                                "archive-list",
                                                "edit"
                                              ) && (
                                                // <FontAwesomeIcon
                                                //   onClick={() => {
                                                //     handleAssessmentStart(
                                                //       el?.vacancyId,
                                                //       el?.user_id,
                                                //       el?.appl_id,
                                                //       el?.name,
                                                //       jobDetails?.jobDetails
                                                //         ?.title
                                                //     );
                                                //   }}
                                                //   title="Archive Application"
                                                //   icon={faEdit}
                                                //   className="font-size-18"
                                                //   style={{ cursor: "pointer" }}
                                                // />
                                                <img
                                                  src={edit_icon}
                                                  onClick={() => {
                                                    handleAssessmentStart(
                                                      el?.vacancyId,
                                                      el?.user_id,
                                                      el?.appl_id,
                                                      el?.name,
                                                      jobDetails?.jobDetails
                                                        ?.title
                                                    );
                                                  }}
                                                  title="Archive Application"
                                                  className="font-size-18"
                                                  style={{ cursor: "pointer" }}
                                                />
                                              )}
                                              {checkPermissionStatus(
                                                "archive-list",
                                                "edit"
                                              ) && (
                                                // <FontAwesomeIcon
                                                //   onClick={() =>
                                                //     handleArchiveAppplication(
                                                //       el
                                                //     )
                                                //   }
                                                //   title="Archive Application"
                                                //   icon={faArchive}
                                                //   color="red"
                                                //   className="font-size-18"
                                                //   style={{ cursor: "pointer" }}
                                                // />

                                                <img
                                                  src={delete_icon}
                                                  onClick={() =>
                                                    handleArchiveAppplication(
                                                      el
                                                    )
                                                  }
                                                  title="Archive Application"
                                                  color="red"
                                                  className="font-size-18"
                                                  style={{ cursor: "pointer" }}
                                                />
                                              )}
                                            </div>
                                          </div> */}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </Col>
                            </>
                          );
                        })}
                      <Col lg={3}>
                        <div className="new-application selected-card">
                          <h4 className="text-left d-flex align-items-center gap-2 mt-0 new-applica-spl">
                            <div className="checkbox-bedge-card">
                              <div className="checkbox-bedge-card-input">
                                {/* ✅ PARENT CHECKBOX */}
                                <Input
                                  type="checkbox"
                                  id="select-all-checkbox-inprogress"
                                  className="font-size-20"
                                  title={t(`ATS View.Select All`)}
                                  checked={isAllGroupSelected("inprogress")}
                                  onChange={e =>
                                    handleSelectCandidateMulti(
                                      e.target.checked,
                                      "inprogress"
                                    )
                                  }
                                />
                                <label
                                  htmlFor="select-all-checkbox-inprogress"
                                  className="checkbox-label hide-class"
                                >
                                  {t(`ATS View.Select All`)}
                                </label>
                              </div>
                            </div>

                            <div>
                              {t(`ATS View.Inprogress_Applications`)}{" "}
                              <span>
                                ({filteredInprogressApplicants?.length || 0})
                              </span>
                            </div>
                          </h4>

                          {filteredInprogressApplicants?.map(el => (
                            <div
                              key={el?.appl_id}
                              className="job-post-minicard"
                            >
                              <h5 className="text-capitalize d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center gap-2">
                                  <div className="checkbox-bedge-card">
                                    <div className="checkbox-bedge-card-input">
                                      {/* ✅ CHILD CHECKBOX (FIXED) */}
                                      <Input
                                        type="checkbox"
                                        id={`checkbox-${el?.appl_id}`}
                                        checked={isCandidateChecked(el)}
                                        onChange={e =>
                                          handleSelectCandidate(
                                            e.target.checked,
                                            el,
                                            "inprogress"
                                          )
                                        }
                                      />
                                      <label
                                        htmlFor={`checkbox-${el?.appl_id}`}
                                        className="checkbox-label hide-class"
                                      >
                                        Select candidate {el?.appl_id}
                                      </label>
                                    </div>
                                  </div>

                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      history.push(
                                        `/candidate_consolidate/view-details/${el?.appl_id}`
                                      )
                                    }
                                  >
                                    {el?.name || ""}
                                  </span>
                                </div>

                                <div className="checkbox-bedge-card">
                                  {el?.jobSkills?.length > 0 && (
                                    <div className="checkbox-bedge-html">
                                      <span>
                                        <img src={html_bedge} alt="" />
                                      </span>
                                      {el?.jobSkills?.[0]?.name}{" "}
                                      {el?.jobSkills?.length - 1}+
                                    </div>
                                  )}
                                </div>
                              </h5>

                              <div className="applied-job">
                                <div className="applied-card-text auto-screening">
                                  <span>
                                    <img src={applieds} alt="applied" />
                                  </span>
                                  <p>{t(`ATS View.inporgress`)}</p>
                                </div>

                                <div className="date-card applied-card-text">
                                  <span>
                                    <img src={calendar} alt="calendar" />
                                  </span>
                                  <h6>
                                    {el?.status_updatedAt
                                      ? moment(
                                          getCompanyTimezoneDateTime(
                                            el?.status_updatedAt
                                          )
                                        ).format("Do MMM,YYYY")
                                      : "N.A."}
                                  </h6>
                                </div>
                              </div>

                              <div className="applied-job">
                                <ul>
                                  {getSubdomain() !== "mahindra" && (
                                    <li>
                                      <div className="behavirour-score">
                                        <p>
                                          {t(`ATS View.Behavioural Score`)}{" "}
                                          {el?.behavioural_score}%
                                        </p>
                                      </div>
                                    </li>
                                  )}
                                  <li>
                                    <div
                                      className={
                                        parseInt(el?.relevancy_score) < 50
                                          ? "text-danger low-match"
                                          : parseInt(el?.relevancy_score) < 76
                                          ? "text-warning medium-match"
                                          : "text-success high-match"
                                      }
                                    >
                                      <p>
                                        {el?.relevancy_score}%{" "}
                                        {parseInt(el?.relevancy_score) < 50
                                          ? t(`ATS View.Low Match`)
                                          : parseInt(el?.relevancy_score) < 76
                                          ? t(`ATS View.Medium Match`)
                                          : t(`ATS View.High Match`)}
                                      </p>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                              {getSubdomain() === "mahindra" && (
                                <div className="applied-job">
                                  <ul>
                                    <li>
                                      <div className="behavirour-score">
                                        <p>
                                          {t(`ATS View.Pre_Assessment_Score`)}{" "}
                                          {el?.assessment_score}%{" "}
                                        </p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              )}
                              <div className="text-muted mathc-card d-flex justify-content-between">
                                <div className="assesment-centre-btn"></div>

                                <div className="assesment-centre-btn">
                                  <Link to="" className="assesment-centre">
                                    <span>
                                      <img
                                        src={assessment_icon_img}
                                        alt="archive"
                                        onClick={() =>
                                          handleArchiveAppplication(el)
                                        }
                                        title={t(
                                          `ATS View.Archive Application`
                                        )}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Col>

                      <Col lg={3}>
                        <div className="new-application selected-card">
                          <h4 className="text-left d-flex align-items-center gap-2 mt-0 new-applica-spl">
                            <div className="checkbox-bedge-card">
                              <div className="checkbox-bedge-card-input">
                                <Input
                                  type="checkbox"
                                  id="select-all-checkbox2"
                                  className="font-size-20"
                                  title={t(`ATS View.Select All`)}
                                  checked={isAllGroupSelected("selected")}
                                  onChange={e =>
                                    handleSelectCandidateMulti(
                                      e.target.checked,
                                      "selected"
                                    )
                                  }
                                  defaultChecked={false}
                                />
                                <label
                                  htmlFor="select-all-checkbox2"
                                  className="checkbox-label hide-class"
                                >
                                  {t(`ATS View.Select All`)}{" "}
                                  {/* Add the label text */}
                                </label>
                              </div>
                            </div>
                            <div>
                              {t(`ATS View.Selected Applications`)}{" "}
                              <span>
                                ({filteredselectedApplicants?.length || 0})
                              </span>
                            </div>
                          </h4>

                          {filteredselectedApplicants?.map(el => {
                            return (
                              <div
                                key={el?.appl_id}
                                className="job-post-minicard"
                              >
                                <h5 className="text-capitalize d-flex align-items-center justify-content-between">
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="checkbox-bedge-card">
                                      <div className="checkbox-bedge-card-input">
                                        <Input
                                          type="checkbox"
                                          id={`checkbox-${el?.appl_id}`}
                                          onChange={e =>
                                            handleSelectCandidate(
                                              e.target.checked,
                                              el,
                                              "selected"
                                            )
                                          }
                                          checked={isCandidateSelected(el)}
                                        />
                                        <label
                                          htmlFor={`checkbox-${el?.appl_id}`}
                                          className="checkbox-label hide-class"
                                        >
                                          Select candidate {el?.appl_id}{" "}
                                          {/* Customize the label text as needed */}
                                        </label>
                                      </div>
                                    </div>
                                    <span
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(
                                          `/candidate_consolidate/view-details/${el?.appl_id}`
                                        );
                                      }}
                                    >
                                      {el?.name || ""}
                                    </span>
                                  </div>
                                  <div className="checkbox-bedge-card">
                                    {el?.jobSkills?.length > 0 && (
                                      <div className="checkbox-bedge-html">
                                        <span>
                                          <img src={html_bedge} alt="" />
                                        </span>
                                        {el?.jobSkills?.[0]?.name}{" "}
                                        {el?.jobSkills?.length - 1}+
                                      </div>
                                    )}
                                  </div>
                                </h5>

                                <div className="applied-job">
                                  <div className="applied-card-text  auto-screening">
                                    <span>
                                      <img src={applieds} alt="applied" />
                                    </span>
                                    <p>{t(`ATS View.Selected`)}</p>
                                  </div>

                                  <div className="date-card applied-card-text">
                                    <span>
                                      <img src={calendar} alt="applied" />
                                    </span>
                                    <h6>
                                      {el?.status_updatedAt
                                        ? moment(
                                            getCompanyTimezoneDateTime(
                                              el?.status_updatedAt
                                            )
                                          ).format("Do MMM,YYYY")
                                        : "N.A."}
                                    </h6>
                                  </div>
                                </div>

                                <div className="applied-job">
                                  <ul>
                                    {/* <li>
                                      <div className="rating-schedule">
                                        <span>
                                          <img src={star} alt="" />
                                        </span>
                                        4.5
                                      </div>
                                    </li> */}
                                    {getSubdomain() !== "mahindra" && (
                                      <li>
                                        <div className="behavirour-score">
                                          <p>
                                            {t(`ATS View.Behavioural Score`)}{" "}
                                            {el?.behavioural_score}%{" "}
                                          </p>
                                        </div>
                                      </li>
                                    )}
                                    <li>
                                      <div
                                        className={
                                          parseInt(el?.relevancy_score) < 50
                                            ? "text-danger low-match" // Low score (red)
                                            : parseInt(el?.relevancy_score) >=
                                                50 &&
                                              parseInt(el?.relevancy_score) < 76
                                            ? "text-warning  medium-match" // Medium score (yellow)
                                            : "text-success  high-match" // High score (green)
                                        }
                                      >
                                        <p>
                                          {el?.relevancy_score}%{" "}
                                          {parseInt(el?.relevancy_score) < 50
                                            ? t(`ATS View.Low Match`)
                                            : parseInt(el?.relevancy_score) >=
                                                50 &&
                                              parseInt(el?.relevancy_score) < 76
                                            ? t(`ATS View.Medium Match`)
                                            : t(`ATS View.High Match`)}
                                        </p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                {getSubdomain() === "mahindra" && (
                                  <div className="applied-job">
                                    <ul>
                                      <li>
                                        <div className="behavirour-score">
                                          <p>
                                            {t(`ATS View.Pre_Assessment_Score`)}{" "}
                                            {el?.assessment_score}%{" "}
                                          </p>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                                <div className="text-muted mathc-card d-flex justify-content-between">
                                  <div className="assesment-centre-btn"></div>

                                  <div className="assesment-centre-btn">
                                    <Link to="" className="assesment-centre">
                                      <span>
                                        <img
                                          src={assessment_icon_img}
                                          alt="eyes"
                                          onClick={() =>
                                            handleArchiveAppplication(el)
                                          }
                                          title={t(
                                            `ATS View.Archive Application`
                                          )}
                                          color="red"
                                          style={{ cursor: "pointer" }}
                                        />
                                      </span>
                                    </Link>
                                  </div>
                                </div>

                                {/* <div className="text-muted mathc-card d-flex justify-content-between">
                                  <div className="d-flex align-items-center gap-2">
                                    <h6>
                                      <span
                                        className={
                                          parseInt(el?.relevancy_score) < 50
                                            ? "text-danger"
                                            : parseInt(el?.relevancy_score) >
                                                50 &&
                                              parseInt(el?.relevancy_score) < 76
                                            ? "text-warning"
                                            : "text-success"
                                        }
                                      >
                                        {el?.relevancy_score} %
                                      </span>
                                    </h6>
                                    <span>Match</span>
                                  </div>
                                  <div className="handle-app d-flex gap-3">
                                    {checkPermissionStatus(
                                      "archive-list",
                                      "edit"
                                    ) && (
                                      // <FontAwesomeIcon
                                      //   onClick={() =>
                                      //     handleArchiveAppplication(el)
                                      //   }
                                      //   title="Archive Application"
                                      //   icon={faArchive}
                                      //   color="red"
                                      //   className="font-size-18"
                                      //   style={{ cursor: "pointer" }}
                                      // />

                                      <img
                                        src={delete_icon}
                                        onClick={() =>
                                          handleArchiveAppplication(el)
                                        }
                                        title="Archive Application"
                                        color="red"
                                        className="font-size-18"
                                        style={{ cursor: "pointer" }}
                                      />
                                    )}
                                  </div>
                                </div> */}
                              </div>
                            );
                          })}
                        </div>
                      </Col>

                      <Col lg={3}>
                        <div className="new-application cyan-card">
                          <h4 className="text-left d-flex align-items-center mt-0 gap-2 new-applica-spl">
                            <div className="checkbox-bedge-card">
                              <div className="checkbox-bedge-card-input">
                                <Input
                                  type="checkbox"
                                  id="select-all-checkbox3"
                                  className="font-size-20"
                                  title="Select All"
                                  checked={isAllGroupSelected("onboarded")}
                                  onChange={e =>
                                    handleSelectCandidateMulti(
                                      e.target.checked,
                                      "onboarded"
                                    )
                                  }
                                  defaultChecked={false}
                                />
                                <label
                                  htmlFor="select-all-checkbox3"
                                  className="checkbox-label hide-class"
                                >
                                  Select All
                                </label>
                              </div>
                            </div>
                            <div>
                              {t(`ATS View.Onboarded Applications`)}{" "}
                              <span>
                                ({filteredonboardedApplicants?.length || 0})
                              </span>
                            </div>
                          </h4>

                          {filteredonboardedApplicants?.map(el => {
                            return (
                              <div
                                key={el?.appl_id}
                                className="job-post-minicard"
                              >
                                <h5 className="text-capitalize d-flex align-items-center justify-content-between">
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="checkbox-bedge-card">
                                      <div className="checkbox-bedge-card-input">
                                        <label
                                          htmlFor={`checkbox-${el.id}`}
                                          className="checkbox-label hide-class"
                                        >
                                          Select Candidate
                                        </label>
                                        <Input
                                          type="checkbox"
                                          id={`checkbox-${el.id}`} // Unique ID for accessibility
                                          onChange={e =>
                                            handleSelectCandidate(
                                              e.target.checked,
                                              el,
                                              "onboarded"
                                            )
                                          }
                                          checked={isCandidateSelected(el)}
                                        />
                                      </div>
                                    </div>
                                    <span
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(
                                          `/candidate_consolidate/view-details/${el?.appl_id}`
                                        );
                                      }}
                                    >
                                      {el?.name || ""}
                                    </span>
                                  </div>
                                  <div className="checkbox-bedge-card">
                                    {el?.jobSkills?.length > 0 && (
                                      <div className="checkbox-bedge-html">
                                        <span>
                                          <img src={html_bedge} alt="" />
                                        </span>
                                        {el?.jobSkills?.[0]?.name}{" "}
                                        {el?.jobSkills?.length - 1}+
                                      </div>
                                    )}
                                  </div>
                                </h5>

                                <div className="applied-job">
                                  <div className="applied-card-text  auto-screening">
                                    <span>
                                      <img src={applieds} alt="applied" />
                                    </span>
                                    <p>{t(`ATS View.Onboarded`)}</p>
                                  </div>

                                  <div className="date-card applied-card-text">
                                    <span>
                                      <img src={calendar} alt="applied" />
                                    </span>
                                    <h6>
                                      {el?.status_updatedAt
                                        ? moment(
                                            getCompanyTimezoneDateTime(
                                              el?.status_updatedAt
                                            )
                                          ).format("Do MMM,YYYY")
                                        : "N.A."}
                                    </h6>
                                  </div>
                                </div>

                                <div className="applied-job">
                                  <ul>
                                    {/* <li>
                                      <div className="rating-schedule">
                                        <span>
                                          <img src={star} alt="" />
                                        </span>
                                        4.5
                                      </div>
                                    </li> */}
                                    {getSubdomain() !== "mahindra" && (
                                      <li>
                                        <div className="behavirour-score">
                                          <p>
                                            {t(`ATS View.Behavioural Score`)}{" "}
                                            {el?.behavioural_score}%{" "}
                                          </p>
                                        </div>
                                      </li>
                                    )}
                                    <li>
                                      <div
                                        className={
                                          parseInt(el?.relevancy_score) < 50
                                            ? "text-danger low-match" // Low score (red)
                                            : parseInt(el?.relevancy_score) >=
                                                50 &&
                                              parseInt(el?.relevancy_score) < 76
                                            ? "text-warning  medium-match" // Medium score (yellow)
                                            : "text-success  high-match" // High score (green)
                                        }
                                      >
                                        <p>
                                          {el?.relevancy_score}%{" "}
                                          {parseInt(el?.relevancy_score) < 50
                                            ? t(`ATS View.Low Match`)
                                            : parseInt(el?.relevancy_score) >=
                                                50 &&
                                              parseInt(el?.relevancy_score) < 76
                                            ? t(`ATS View.Medium Match`)
                                            : t(`ATS View.High Match`)}
                                        </p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                {getSubdomain() === "mahindra" && (
                                  <div className="applied-job">
                                    <ul>
                                      <li>
                                        <div className="behavirour-score">
                                          <p>
                                            {t(`ATS View.Pre_Assessment_Score`)}{" "}
                                            {el?.assessment_score}%{" "}
                                          </p>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                                <div className="text-muted mathc-card d-flex justify-content-between">
                                  <div className="assesment-centre-btn">
                                    {/* <Link
                                      to=""
                                      className="assesment-centre-btn1 btn btn-primary"
                                    >
                                      <span>
                                        <img src={eyes_icon} alt="eyes" />
                                      </span>
                                      Assessment Center
                                    </Link> */}
                                  </div>

                                  <div className="assesment-centre-btn">
                                    <Link to="" className="assesment-centre">
                                      <span>
                                        <img
                                          src={assessment_icon_img}
                                          alt="eyes"
                                          onClick={() =>
                                            handleArchiveAppplication(el)
                                          }
                                          title={t(
                                            `ATS View.Archive Application`
                                          )}
                                          color="red"
                                          style={{ cursor: "pointer" }}
                                        />
                                      </span>
                                    </Link>
                                  </div>
                                </div>

                                {/* <div className="text-muted mathc-card d-flex justify-content-between">
                                  <div className="d-flex align-items-center gap-2">
                                    <h6>
                                      <span
                                        className={
                                          parseInt(el?.relevancy_score) < 50
                                            ? "text-danger"
                                            : parseInt(el?.relevancy_score) >
                                                50 &&
                                              parseInt(el?.relevancy_score) < 76
                                            ? "text-warning"
                                            : "text-success"
                                        }
                                      >
                                        {el?.relevancy_score} %
                                      </span>
                                    </h6>
                                    <span>Match</span>
                                  </div>
                                  <div className="handle-app d-flex gap-3">
                                    {checkPermissionStatus(
                                      "archive-list",
                                      "edit"
                                    ) && (
                                      // <FontAwesomeIcon
                                      //   onClick={() =>
                                      //     handleArchiveAppplication(el)
                                      //   }
                                      //   title="Archive Application"
                                      //   icon={faArchive}
                                      //   color="red"
                                      //   className="font-size-18"
                                      //   style={{ cursor: "pointer" }}
                                      // />

                                      <img
                                        src={delete_icon}
                                        onClick={() =>
                                          handleArchiveAppplication(el)
                                        }
                                        title="Archive Application"
                                        color="red"
                                        className="font-size-18"
                                        style={{ cursor: "pointer" }}
                                      />
                                    )}
                                  </div>
                                </div> */}
                              </div>
                            );
                          })}
                        </div>
                      </Col>

                      <Col lg={3}>
                        <div className="new-application yellow-card">
                          <h4 className="text-left d-flex align-items-center  gap-2 mt-0 new-applica-spl">
                            <div className="checkbox-bedge-card">
                              <div className="checkbox-bedge-card-body">
                                <Input
                                  id="select-all-checkbox4"
                                  type="checkbox"
                                  className="font-size-20"
                                  title={t(`ATS View.Select All`)}
                                  checked={isAllGroupSelected("hold")}
                                  onChange={e =>
                                    handleSelectCandidateMulti(
                                      e.target.checked,
                                      "hold"
                                    )
                                  }
                                  defaultChecked={false}
                                />
                                <label
                                  htmlFor="select-all-checkbox4"
                                  className="checkbox-label hide-class"
                                >
                                  {t(`ATS View.Select All`)}
                                </label>
                              </div>
                            </div>
                            <div>
                              {t(`ATS View.On Hold Applications`)}{" "}
                              <span>
                                ({filteredonholdApplicants?.length || 0})
                              </span>
                            </div>
                          </h4>

                          {filteredonholdApplicants?.map(el => {
                            return (
                              <div
                                key={el?.appl_id}
                                className="job-post-minicard"
                              >
                                <h5 className="text-capitalize d-flex align-items-center justify-content-between">
                                  <div className=" d-flex align-items-center gap-2">
                                    <div className="checkbox-bedge-card">
                                      <div className="checkbox-bedge-card-input">
                                        <Input
                                          type="checkbox"
                                          id={`candidate-${el.id}`} // Ensure unique id for each checkbox
                                          onChange={e =>
                                            handleSelectCandidate(
                                              e.target.checked,
                                              el,
                                              "hold"
                                            )
                                          }
                                          checked={isCandidateSelected(el)}
                                        />
                                        <label
                                          htmlFor={`candidate-${el.id}`}
                                          className="checkbox-label hide-class"
                                        >
                                          Select Candidate {el.name}{" "}
                                          {/* Replace with meaningful text */}
                                        </label>
                                      </div>
                                    </div>
                                    <span
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(
                                          `/candidate_consolidate/view-details/${el?.appl_id}`
                                        );
                                      }}
                                    >
                                      {el?.name || ""}
                                    </span>
                                  </div>
                                  <div className="checkbox-bedge-card">
                                    {el?.jobSkills?.length > 0 && (
                                      <div className="checkbox-bedge-html">
                                        <span>
                                          <img src={html_bedge} alt="" />
                                        </span>
                                        {el?.jobSkills?.[0]?.name}{" "}
                                        {el?.jobSkills?.length - 1}+
                                      </div>
                                    )}
                                  </div>
                                </h5>

                                <div className="applied-job">
                                  <div className="applied-card-text  auto-screening">
                                    <span>
                                      <img src={applieds} alt="applied" />
                                    </span>
                                    <p>{t(`ATS View.On Hold`)}</p>
                                  </div>

                                  <div className="date-card applied-card-text">
                                    <span>
                                      <img src={calendar} alt="applied" />
                                    </span>
                                    <h6>
                                      {el?.status_updatedAt
                                        ? moment(
                                            getCompanyTimezoneDateTime(
                                              el?.status_updatedAt
                                            )
                                          ).format("Do MMM,YYYY")
                                        : "N.A."}
                                    </h6>
                                  </div>
                                </div>

                                <div className="applied-job">
                                  <ul>
                                    {/* <li>
                                      <div className="rating-schedule">
                                        <span>
                                          <img src={star} alt="" />
                                        </span>
                                        4.5
                                      </div>
                                    </li> */}
                                    {getSubdomain() !== "mahindra" && (
                                      <li>
                                        <div className="behavirour-score">
                                          <p>
                                            {t(`ATS View.Behavioural Score`)}{" "}
                                            {el?.behavioural_score}%{" "}
                                          </p>
                                        </div>
                                      </li>
                                    )}
                                    <li>
                                      <div
                                        className={
                                          parseInt(el?.relevancy_score) < 50
                                            ? "text-danger low-match" // Low score (red)
                                            : parseInt(el?.relevancy_score) >=
                                                50 &&
                                              parseInt(el?.relevancy_score) < 76
                                            ? "text-warning  medium-match" // Medium score (yellow)
                                            : "text-success  high-match" // High score (green)
                                        }
                                      >
                                        <p>
                                          {el?.relevancy_score}%{" "}
                                          {parseInt(el?.relevancy_score) < 50
                                            ? t(`ATS View.Low Match`)
                                            : parseInt(el?.relevancy_score) >=
                                                50 &&
                                              parseInt(el?.relevancy_score) < 76
                                            ? t(`ATS View.Medium Match`)
                                            : t(`ATS View.High Match`)}
                                        </p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                {getSubdomain() === "mahindra" && (
                                  <div className="applied-job">
                                    <ul>
                                      <li>
                                        <div className="behavirour-score">
                                          <p>
                                            {t(`ATS View.Pre_Assessment_Score`)}{" "}
                                            {el?.assessment_score}%{" "}
                                          </p>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                                <div className="text-muted mathc-card d-flex justify-content-between">
                                  <div className="assesment-centre-btn">
                                    {/* <Link
                                      to=""
                                      className="assesment-centre-btn1 btn btn-primary"
                                    >
                                      <span>
                                        <img src={eyes_icon} alt="eyes" />
                                      </span>
                                      Assessment Center
                                    </Link> */}
                                  </div>

                                  <div className="assesment-centre-btn">
                                    <Link to="" className="assesment-centre">
                                      <span>
                                        <img
                                          src={assessment_icon_img}
                                          alt="eyes"
                                          onClick={() =>
                                            handleArchiveAppplication(el)
                                          }
                                          title={t(
                                            `ATS View.Archive Application`
                                          )}
                                          style={{ cursor: "pointer" }}
                                        />
                                      </span>
                                    </Link>
                                  </div>
                                </div>

                                {/* <div className="text-muted mathc-card d-flex justify-content-between">
                                  <div className="d-flex align-items-center gap-2">
                                    <h6>
                                      <span
                                        className={
                                          parseInt(el?.relevancy_score) < 50
                                            ? "text-danger"
                                            : parseInt(el?.relevancy_score) >
                                                50 &&
                                              parseInt(el?.relevancy_score) < 76
                                            ? "text-warning"
                                            : "text-success"
                                        }
                                      >
                                        {el?.relevancy_score} %
                                      </span>
                                    </h6>
                                    <span>Match</span>
                                  </div>
                                  <div className="handle-app d-flex gap-3">
                                    {checkPermissionStatus(
                                      "archive-list",
                                      "edit"
                                    ) && (
                                      // <FontAwesomeIcon
                                      //   onClick={() =>
                                      //     handleArchiveAppplication(el)
                                      //   }
                                      //   title="Archive Application"
                                      //   icon={faArchive}
                                      //   color="red"
                                      //   className="font-size-18"
                                      //   style={{ cursor: "pointer" }}
                                      // />

                                      <img
                                        src={delete_icon}
                                        onClick={() =>
                                          handleArchiveAppplication(el)
                                        }
                                        title="Archive Application"
                                        color="red"
                                        className="font-size-18"
                                        style={{ cursor: "pointer" }}
                                      />
                                    )}
                                  </div>
                                </div> */}
                              </div>
                            );
                          })}
                        </div>
                      </Col>

                      <Col lg={3}>
                        <div className="new-application red-card redcardhire">
                          <h4 className="text-left d-flex align-items-center mt-0 justify-content-between gap-2 moble-view-remove  new-applica-spl">
                            <div className="text-left d-flex align-items-center gap-2">
                              <div className="checkbox-bedge-card">
                                <div className="checkbox-bedge-card-input">
                                  <Input
                                    id="select-all-checkbox5"
                                    type="checkbox"
                                    className="font-size-20"
                                    title="Select All"
                                    checked={isAllGroupSelected("rejected")}
                                    onChange={e =>
                                      handleSelectCandidateMulti(
                                        e.target.checked,
                                        "rejected"
                                      )
                                    }
                                    defaultChecked={false}
                                  />
                                  <label
                                    htmlFor="select-all-checkbox5"
                                    className="checkbox-label hide-class"
                                  >
                                    Select All
                                  </label>
                                </div>
                              </div>
                              <div>
                                {t(`ATS View.Rejected Applications`)}{" "}
                                <span>
                                  ({filteredrejectedApplicants?.length || 0})
                                </span>
                              </div>
                            </div>

                            <div className="filter-select-wrapper">
                              <select
                                id="filter-select"
                                value={filter}
                                onChange={handleFilterChange}
                                className="filter-select form-select form-control"
                              >
                                <option value="all">{t(`ATS View.All`)}</option>
                                <option value="rejected">
                                  {t(`ATS View.Rejected`)}
                                </option>
                                <option value="auto-rejected">
                                  {t(`ATS View.Auto-Rejected`)}
                                </option>
                              </select>
                            </div>
                          </h4>

                          {filteredrejectedApplicants?.map(el => {
                            return (
                              <div
                                key={el?.appl_id}
                                className="job-post-minicard"
                              >
                                <h5 className="text-capitalize d-flex align-items-center justify-content-between">
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="checkbox-bedge-card">
                                      <div className="checkbox-bedge-card-input">
                                        <Input
                                          id={`candidate-checkbox-${el.id}`} // Ensure unique id for each checkbox
                                          type="checkbox"
                                          onChange={e =>
                                            handleSelectCandidate(
                                              e.target.checked,
                                              el,
                                              "rejected"
                                            )
                                          }
                                          checked={isCandidateSelected(el)}
                                        />
                                        <label
                                          htmlFor={`candidate-checkbox-${el.id}`}
                                          className="checkbox-label hide-class"
                                        >
                                          Select Candidate{" "}
                                          {/* Add descriptive text */}
                                        </label>
                                      </div>
                                    </div>
                                    <span
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(
                                          `/candidate_consolidate/view-details/${el?.appl_id}`
                                        );
                                      }}
                                    >
                                      {el?.name || ""}
                                    </span>
                                  </div>
                                  <div className="checkbox-bedge-card">
                                    {el?.jobSkills?.length > 0 && (
                                      <div className="checkbox-bedge-html">
                                        <span>
                                          <img src={html_bedge} alt="" />
                                        </span>
                                        {el?.jobSkills?.[0]?.name}{" "}
                                        {el?.jobSkills?.length - 1}+
                                      </div>
                                    )}
                                  </div>
                                </h5>

                                <div className="applied-job">
                                  <div className="applied-card-text  auto-screening">
                                    <span>
                                      <img src={applieds} alt="applied" />
                                    </span>
                                    {/* Updated to check is_auto_rejected */}
                                    <p>
                                      {el?.is_auto_rejected === 1
                                        ? t(`ATS View.Auto-Rejected`)
                                        : t(`ATS View.Rejected`)}
                                    </p>
                                  </div>

                                  <div className="date-card applied-card-text">
                                    <span>
                                      <img src={calendar} alt="applied" />
                                    </span>
                                    <h6>
                                      {el?.status_updatedAt
                                        ? moment(
                                            getCompanyTimezoneDateTime(
                                              el?.status_updatedAt
                                            )
                                          ).format("Do MMM,YYYY")
                                        : "N.A."}
                                    </h6>
                                  </div>
                                </div>
                                {getSubdomain() !== "mahindra" && (
                                  <div className="applied-job">
                                    <ul>
                                      {/* <li>
                                      <div className="rating-schedule">
                                        <span>
                                          <img src={star} alt="" />
                                        </span>
                                        4.5
                                      </div>
                                    </li> */}

                                      <li>
                                        <div className="behavirour-score">
                                          <p>
                                            {t(`ATS View.Behavioural Score`)}{" "}
                                            {el?.behavioural_score}%{" "}
                                          </p>
                                        </div>
                                      </li>

                                      <li>
                                        <div className="high-match">
                                          <p>84% {t(`ATS View.High Match`)}</p>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                                {getSubdomain() === "mahindra" && (
                                  <div className="applied-job">
                                    <ul>
                                      <li>
                                        <div className="behavirour-score">
                                          <p>
                                            {t(`ATS View.Pre_Assessment_Score`)}{" "}
                                            {el?.assessment_score}%{" "}
                                          </p>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                                <div className="text-muted mathc-card d-flex justify-content-between">
                                  <div className="assesment-centre-btn">
                                    {/* <Link
                                      to=""
                                      className="assesment-centre-btn1 btn btn-primary"
                                    >
                                      <span>
                                        <img src={eyes_icon} alt="eyes" />
                                      </span>
                                      Assessment Center
                                    </Link> */}
                                  </div>

                                  <div className="assesment-centre-btn">
                                    <Link to="" className="assesment-centre">
                                      <span>
                                        <img
                                          src={assessment_icon_img}
                                          alt="eyes"
                                          onClick={() =>
                                            handleArchiveAppplication(el)
                                          }
                                          title={t(
                                            `ATS View.Archive Application`
                                          )}
                                          style={{ cursor: "pointer" }}
                                        />
                                      </span>
                                    </Link>
                                  </div>
                                </div>

                                {/* <div className="text-muted mathc-card d-flex justify-content-between">
                                  <div className="d-flex align-items-center gap-2">
                                    <h6>
                                      <span
                                        className={
                                          parseInt(el?.relevancy_score) < 50
                                            ? "text-danger"
                                            : parseInt(el?.relevancy_score) >
                                                50 &&
                                              parseInt(el?.relevancy_score) < 76
                                            ? "text-warning"
                                            : "text-success"
                                        }
                                      >
                                        {el?.relevancy_score} %
                                      </span>
                                    </h6>
                                    <span>Match</span>
                                  </div>
                                  <div className="handle-app d-flex gap-3">
                                    {checkPermissionStatus(
                                      "archive-list",
                                      "edit"
                                    ) && (
                                      // <FontAwesomeIcon
                                      //   onClick={() =>
                                      //     handleArchiveAppplication(el)
                                      //   }
                                      //   title="Archive Application"
                                      //   icon={faArchive}
                                      //   color="red"
                                      //   className="font-size-18"
                                      //   style={{ cursor: "pointer" }}
                                      // />

                                      <img
                                        src={delete_icon}
                                        onClick={() =>
                                          handleArchiveAppplication(el)
                                        }
                                        title="Archive Application"
                                        color="red"
                                        className="font-size-18"
                                        style={{ cursor: "pointer" }}
                                      />
                                    )}
                                  </div>
                                </div> */}
                              </div>
                            );
                          })}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
              {loading && (
                <div className="p-3 text-center d-flex justify-content-center flex-column jobposting-card">
                  <div>
                    {" "}
                    <Spinner />
                  </div>
                  <h5>{t(`ATS View.Loading`)}</h5>
                </div>
              )}
            </Row>

            <Modal
              size="lg"
              show={isFeedback}
              className="edit-modal-card asseentModal"
              onHide={() => feedback_close()}
            >
              <Modal.Body>
                <div className="filter-shadow reject-people-data">
                  <div className="filters-cards">
                    <div className="filters-cards-cross">
                      <div className="filter-content">
                        <h4>{t(`ATS View.Application Feedback`)}</h4>
                      </div>
                      <div
                        className="filter-content cross"
                        onClick={feedback_close}
                      >
                        <img src={cross} alt="" />
                      </div>
                    </div>
                    <div className="reject-people data">
                      <div className="data-people">
                        <div className="people-biodata">
                          <div className="icon-name">
                            <img src={name_icon} alt="" />
                          </div>
                          <div className="people-name">
                            <p>{t(`ATS View.Name`)}</p>
                            <h4>{candidateDetails?.name}</h4>
                          </div>
                        </div>

                        <div className="people-biodata">
                          <div className="icon-name">
                            <img src={job} alt="" />
                          </div>
                          <div className="people-name">
                            <p>{t(`ATS View.Job Role`)}</p>
                            <h4>{candidateDetails?.vacancy?.title}</h4>
                          </div>
                        </div>
                      </div>

                      <div className="data-people">
                        <div className="people-biodata">
                          <div className="icon-name">
                            <img src={education} alt="" />
                          </div>
                          <div className="people-name">
                            <p>{t(`ATS View.Education`)}</p>
                            <h4>
                              {
                                selectedCandidate?.allInfo
                                  ?.master_reference_table
                                  ?.highest_qualification
                              }
                            </h4>
                          </div>
                        </div>

                        <div className="people-biodata">
                          <div className="icon-name">
                            <img src={star_exp} alt="" />
                          </div>
                          <div className="people-name">
                            <p>{t(`ATS View.Total Experience`)}</p>
                            <h4>
                              {selectedCandidate?.allInfo?.job_user
                                ?.total_experience + t(`View Details.Years`)}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="filter-cards-form reject-data">
                      <form class="form-inline">
                        <div className="col-lg-12">
                          <label> {t(`ATS View.Add Rating`)}</label>
                          {categories?.map((category, index) => (
                            <div
                              key={index}
                              className="category-rating d-flex "
                            >
                              <h5 className="">{category.name}</h5>
                              <RatingStars
                                totalStars={category.totalStars}
                                onChange={rating =>
                                  handleChangeRating(category.name, rating)
                                }
                              />
                            </div>
                          ))}
                        </div>

                        <div className="col-lg-12 pt-3">
                          <label> {t(`ATS View.Add Comment`)}</label>
                          <Form.Group>
                            <textarea
                              class="form-control"
                              id="exampleFormControlTextarea1"
                              placeholder={t(`ATS View.Comment is compulsory`)}
                              rows="3"
                              name="comment"
                              onChange={handleChange}
                            ></textarea>
                            {commentError && (
                              <div className="text-danger">{commentError}</div>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-lg-12">
                          <div className="serach-btn">
                            <a
                              href="javascript:void(0);"
                              id="next"
                              class="nxt_prev_ques btn btn-primary btn-lg next-btn"
                              onClick={() =>
                                handlefeedback(candidateDetails?.appl_id, 8)
                              }
                            >
                              {t(`ATS View.Submit`)}
                            </a>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="black-showd"></div>
                </div>
              </Modal.Body>
            </Modal>

            <Modal
              size="lg"
              show={assessmentModal}
              onHide={() => handleCloseAssessmentModal()}
              className="edit-modal-card asseentModal screeningtest"
            >
              <Modal.Body>
                <div className="filters-cards-cross">
                  <div className="filter-content">
                    <h4>{t(`ATS View.Assessment Center`)}</h4>
                  </div>
                  <div
                    className="filter-content cross"
                    onClick={handleCloseAssessmentModal}
                  >
                    <img src={cross} alt="" />
                  </div>
                </div>
                <div className="bordertops"></div>
                <div className="row mb-3 invite-for-interview">
                  <div className="reject-people data justify-content-between">
                    <div className="mobile-cards">
                      <div className="reject-perople-user">
                        <img
                          className={
                            selectedCandidate?.candidate_photo
                              ? "image-upload"
                              : "iconuse"
                          }
                          src={
                            selectedCandidate?.candidate_photo || user_icons1
                          }
                          alt="user icon"
                        />
                      </div>
                      <div className="header-plant">
                        <h4
                          style={{ cursor: "pointer", color: "#0c66e4" }}
                          onClick={() => {
                            history.push(
                              `/candidate_consolidate/view-details/${selectedCandidate.appl_id}`
                            );
                          }}
                        >
                          {selectedCandidate?.name}
                        </h4>
                        {Math.round(feedbackInfo?.averageScore * 10) / 10 >
                          0 && (
                          <span className="start-icons">
                            <FontAwesomeIcon
                              icon={faStar}
                              style={{ cursor: "pointer", color: "#FEAE44" }}
                            />
                            {Math.round(feedbackInfo?.averageScore * 10) / 10}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="reject-people-user-data">
                      <div className="header-plant ss">
                        <h4
                          // style={{ cursor: "pointer", color: "#0c66e4" }}
                          onClick={() => {
                            history.push(
                              `/candidate_consolidate/view-details/${selectedCandidate.appl_id}`
                            );
                          }}
                        >
                          {" "}
                          {selectedCandidate?.name}
                        </h4>
                        {Math.round(feedbackInfo?.averageScore * 10) / 10 >
                          0 && (
                          <span className="start-icons">
                            <FontAwesomeIcon
                              icon={faStar}
                              style={{ cursor: "pointer", color: "#FEAE44" }}
                            />
                            {Math.round(feedbackInfo?.averageScore * 10) / 10}
                          </span>
                        )}
                      </div>

                      <div className="reject-people-user-data-card">
                        <div className="people-biodata pb-0">
                          {/* <div className="icon-name">
                          <img src={job} alt="" />
                        </div> */}
                          <div className="people-name">
                            {/* <p>{t(`ATS View.Role Type`)}</p> */}
                            <p>{t(`ATS View.Job Role`)}</p>
                            <h4> {selectedCandidate?.roleType}</h4>
                          </div>
                        </div>

                        <div className="people-biodata pb-0">
                          <div className="people-name">
                            <p>{t(`ATS View.Highest education`)}</p>
                            <h4>
                              {
                                selectedCandidate?.allInfo
                                  ?.master_reference_table
                                  ?.highest_qualification
                              }
                            </h4>
                          </div>
                        </div>

                        <div className="people-biodata pb-0">
                          <div className="people-name">
                            <p>{t(`View Details.Total Experience`)}</p>
                            <h4>
                              {selectedCandidate?.allInfo?.job_user
                                ?.total_experience + t(`View Details.Years`)}
                            </h4>
                          </div>
                        </div>

                        <div className="people-biodata pb-0">
                          <div className="people-name">
                            <p>{t(`ATS View.Applied on`)}</p>
                            <h4> {selectedCandidate?.createdAt}</h4>
                          </div>
                        </div>

                        {selectedCandidate?.allInfo?.job_user?.resume && (
                          <div className="people-biodata resume-last pb-0">
                            <div className="people-name">
                              <p>{t(`View Details.Resume`)}</p>
                              <h4
                                onClick={() =>
                                  window.open(
                                    `${selectedCandidate?.allInfo?.job_user?.resume}`,
                                    "_blank"
                                  )
                                }
                              >
                                <span className="filter-content cross">
                                  {t(`View Details.View Resume`)}
                                </span>
                              </h4>
                            </div>
                          </div>
                        )}
                        <a
                          className="feedback_interview"
                          onClick={() => {
                            setAssessmentModal(false);
                            handleNotes();
                          }}
                        >
                          <img src={addnotoes} alt="write_feedback" />
                          View Notes
                        </a>

                        {/* <div className="form-group">
                      <label>
                        <strong>Candidate Name:</strong>{" "}
                        {selectedCandidate?.name}
                      </label>
                    </div>
                    <div className="form-group">
                      <label className="w-100 text-end">
                        <strong>Role Type:</strong>{" "}
                        {selectedCandidate?.roleType}
                      </label>
                    </div> */}
                      </div>
                    </div>
                  </div>

                  {/* <div className="reject-people data justify-content-between">
                    <div className="people-biodata pb-0">
                      <div className="icon-name">
                        <img src={name_icon} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t(`ATS View.Candidate Name`)}</p>
                        <h4
                          className="clickable-link"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            history.push(
                              `/candidate_consolidate/view-details/${selectedCandidate.appl_id}`
                            );
                          }}
                        >
                          {selectedCandidate?.name}
                        </h4>
                      </div>
                    </div>

                    <div className="people-biodata pb-0">
                      <div className="icon-name">
                        <img src={job} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t(`ATS View.Role Type`)}</p>
                        <h4> {selectedCandidate?.roleType}</h4>
                      </div>
                    </div>

                    <div className="people-biodata pb-0">
                      <div className="icon-name">
                        <img src={archive_book} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t(`ATS View.Applied on`)}</p>
                        <h4> {selectedCandidate?.createdAt}</h4>
                      </div>
                    </div>
                  </div> */}

                  {loading ? (
                    <Spinner size="sm" />
                  ) : (
                    <div className="mt-2 aaessment-card-center">
                      <div className="accrodion-cards-panel">
                        {
                          <RoundList
                            roundListData={roundListData}
                            handleTabClick={handleTabClick}
                            feedbackInfo={feedbackInfo}
                            allNotes={allNotes}
                            handleRemoveNote={handleRemoveNote}
                            toggleReadMore={toggleReadMore}
                            toggleAccordion={toggleAccordion}
                            handleInterviewModal={handleInterviewModal}
                            handleScreenTest={handleScreenTest}
                            setRoundStatus={setRoundStatus}
                            handleUpdateRoundStatus={handleUpdateRoundStatus}
                            getAssesmentLink={getAssesmentLink}
                            handleCopyLink={handleCopyLink}
                            setActiveTab={setActiveTab}
                            activeTab={activeTab}
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                            t={t}
                            roundStatus={roundStatus}
                            readMoreStates={readMoreStates}
                            selectedCandidate={selectedCandidate}
                            open_slider={open_slider}
                            handleShow={handleShow}
                          />
                        }
                      </div>
                    </div>
                  )}
                </div>
              </Modal.Body>
            </Modal>

            <Modal
              size="xl"
              show={isFormVisible}
              onHide={() => handleToggleForm()}
              className="edit-modal-card asseentModal reschedule-calender"
            >
              <Modal.Body>
                <div className="filters-cards-cross">
                  <div className="filter-content">
                    <h4>
                      {" "}
                      {interviewType === "schedule"
                        ? t(`ATS View.Schedule`)
                        : t(`ATS View.Reschedule`)}{" "}
                      {t(`ATS View.Interview`)}
                    </h4>
                  </div>
                  <div
                    className="filter-content cross"
                    onClick={handleToggleForm}
                  >
                    <img src={cross} alt="" />
                  </div>
                </div>
                <div className="bordertops"></div>
                <Form
                  onSubmit={e => {
                    if (interviewType === "schedule") {
                      handleInterviewSubmit(e);
                    } else {
                      handleRescheduleSubmit(e);
                    }
                  }}
                  className="mt-2"
                >
                  <div className="form-group screenest">
                    <div className="row">
                      {/* // Button for Add TimeSlots */}
                      <div className="modal-action-btn text-left mt-4">
                        <button
                          type="submit"
                          disabled={isTimeslotBtnDisabled}
                          className="btn btn-primary mb-2"
                          id="book_schedule"
                          onClick={handleAddTimeslotsClick} // Trigger showing TimeslotBookingAdmin
                        >
                          {t(`ATS View.Add TimeSlots`)}
                        </button>
                      </div>

                      {/* // Conditionally render TimeslotBookingAdmin when showTimeslotBooking is true */}
                      {showTimeslotBooking && (
                        <div>
                          <TimeslotBookingAdmin
                            onValueChange={handleChildValueChange || {}}
                            onErrorHandle={handleErrorsValueChange || {}}
                            defaultTimeSlots={timeSlotsData || {}}
                          />
                          <Form.Group className="cta text-center gap-3 d-flex justify-content-left mt-4 mb-4">
                            <button
                              style={{ marginLeft: "5px" }}
                              className="btn btn-secondary"
                              onClick={handleCancelClick} // Hide TimeslotBookingAdmin on click
                            >
                              {t(`ATS View.Cancel`)}
                            </button>
                            <ButtonLoader
                              title={t(`ATS View.Save Details`)}
                              variant="primary"
                              style={{ marginLeft: "5px" }}
                              type="submit"
                              loading={isLoading}
                              message={"Saving"}
                              onClick={e => {
                                handleTimeslotSubmit(e);
                              }}
                            />
                          </Form.Group>
                        </div>
                      )}

                      <div
                        id="interview-group"
                        className="form-group form-group-lg col-sm-6 formvisible mt-3"
                      >
                        <label>{t(`ATS View.Enter Interview Title`)}:</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={changeHandlers}
                          name="interview_title"
                          id="interview_title"
                          placeholder={t(`ATS View.Enter Interview Title`)}
                          value={formData?.interview_title}
                          disabled
                        />
                        {errors?.interview_title && (
                          <p className="text-danger">
                            {errors?.interview_title}
                          </p>
                        )}
                      </div>
                      <div
                        id="interviewer-group"
                        className="form-group form-group-lg col-sm-6 formvisible mt-3"
                      >
                        <label>{t(`ATS View.Select Interviewer`)}:</label>
                        {/* <select
                          id="interviewere_time"
                          onChange={changeHandlers}
                          name="interviewer_time"
                          className="form-select form-control"
                          data-width="100%"
                          data-size="10"
                          title={t(`ATS View.Select Interviewer`)}
                          value={formData?.interviewer_time}
                        >
                          <option Selected value="0">
                            {t(`ATS View.Select Interviewer`)}
                          </option>
                          {interViewers?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </select> */}
                        <MultiSelect
                          options={
                            Array.isArray(interViewers)
                              ? interViewers.map(el => ({
                                  label: el?.label,
                                  value: el?.value,
                                }))
                              : []
                          }
                          value={selectedOptions}
                          onChange={handleChanges}
                          overrideStrings={{
                            selectSomeItems: t(`ATS View.Select Interviewer`),
                          }}
                        />

                        {errors?.interviewer_time && (
                          <p className="text-danger">
                            {errors?.interviewer_time}
                          </p>
                        )}
                      </div>
                      <div
                        id="int_schedule_date-group"
                        className="form-group form-group-lg col-sm-6 formvisible date-calender mt-3"
                      >
                        <label>{t(`ATS View.Start Date & Time`)}:</label>

                        <div className="d-flex application-card-time">
                          <DatePicker
                            id="int_start_time"
                            name="int_start_time"
                            selected={
                              int_start_time ? new Date(int_start_time) : ""
                            }
                            // onChange={value => {
                            //   if (value >= new Date()) {
                            //     handleStartDateChange(value);
                            //     setErrors({ ...errors, int_start_time: "" });
                            //   } else {
                            //     setErrors({
                            //       ...errors,
                            //       int_start_time: "Cannot Select Past Dates.",
                            //     });
                            //   }
                            // }}
                            onChange={value => handleStartDateChange(value)}
                            selectsStart
                            startDate={
                              int_start_time ? new Date(int_start_time) : ""
                            }
                            endDate={int_end_time ? new Date(int_end_time) : ""}
                            minDate={new Date()}
                            placeholderText={t(`ATS View.dd-mm-yyyy`)}
                            dateFormat="dd-MMM-yyyy"
                            required={true}
                            className={`form-control`}
                            onKeyDown={e => e.preventDefault()}
                            autoComplete="off"
                            // Remove the time-related props
                            // showTimeSelect
                            // timeFormat="HH:mm"
                            // timeIntervals={30}
                            // includeTimes={availableTimes.map(slot => {
                            //   const [startHour, startMinute] = slot.startTime.split(":");
                            //   const today = new Date();
                            //   const selectedTime = new Date(today.setHours(startHour, startMinute));
                            //   return selectedTime;
                            // })}
                            // timeCaption="Time"
                          />
                          <Form.Control
                            as="select"
                            value={selectedStartTime}
                            onChange={e =>
                              handleStartTimeChange(e.target.value)
                            }
                            className="form-control"
                          >
                            <option value="">
                              {t(`ATS View.Select Start Time`)}
                            </option>
                            {sDateTimeSlots?.map((time, index) => (
                              <option key={index} value={time}>
                                {time}
                              </option>
                            ))}
                          </Form.Control>
                        </div>

                        {errors?.selectedStartTime && (
                          <p className="text-danger">
                            {errors?.selectedStartTime}
                          </p>
                        )}
                        <small>{t(`ATS View.Note`)}</small>
                        {errors?.int_start_time && (
                          <p className="text-danger">
                            {errors?.int_start_time}
                          </p>
                        )}
                      </div>
                      <div
                        id="int_schedule_date-group"
                        className="form-group form-group-lg col-sm-6 formvisible date-calender mt-3"
                      >
                        <label>{t(`ATS View.End Date & Time`)}:</label>

                        <div className="d-flex application-card-time">
                          <DatePicker
                            id="int_end_time"
                            name="int_end_time"
                            selected={
                              int_end_time ? new Date(int_end_time) : ""
                            }
                            // onChange={value => {
                            //   if (value >= new Date()) {
                            //     handleEndDateChange(value);
                            //     setErrors({ ...errors, int_end_time: "" });
                            //   } else {
                            //     setErrors({
                            //       ...errors,
                            //       int_end_time: "Cannot Select Past Dates.",
                            //     });
                            //   }
                            // }}
                            onChange={value => handleEndDateChange(value)}
                            selectsEnd
                            startDate={
                              int_start_time ? new Date(int_start_time) : ""
                            }
                            endDate={int_end_time ? new Date(int_end_time) : ""}
                            minDate={
                              int_start_time
                                ? new Date(int_start_time)
                                : new Date()
                            }
                            minimumDate={
                              int_start_time
                                ? int_start_time
                                : utils().getToday()
                            }
                            showFullMonthYearPicker
                            // showTimeSelect
                            placeholderText={t(`ATS View.dd-mm-yyyy`)}
                            // timeFormat="h:mm aa"
                            required={true}
                            // timeIntervals={15}
                            shouldHighlightWeekends
                            calendarPopperPosition="bottom"
                            autoComplete="off"
                            dateFormat="dd-MMM-yyyy"
                            // timeCaption="Time"
                            className={`form-control`}
                            onKeyDown={e => e.preventDefault()}
                          />
                          <Form.Control
                            as="select"
                            value={selectedEndTime}
                            onChange={handleEndTimeChange}
                            className="form-control"
                          >
                            <option value="">
                              {t(`ATS View.Select End Time`)}
                            </option>
                            {eDateTimeSlots?.map((time, index) => (
                              <option key={index} value={time}>
                                {time}
                              </option>
                            ))}
                          </Form.Control>
                        </div>

                        {errors?.selectedEndTime && (
                          <p className="text-danger">
                            {errors?.selectedEndTime}
                          </p>
                        )}
                        {errors?.int_end_time && (
                          <p className="text-danger">{errors?.int_end_time}</p>
                        )}
                      </div>

                      <Row className="mt-3">
                        <Col md={6}>
                          <div
                            id="interviewer-group"
                            className="form-group form-group-lg formvisible"
                          >
                            <label>
                              {t(`ATS View.Select Interview Type`)}:
                            </label>
                            <select
                              id="interviewType"
                              onChange={e => {
                                setFormData(prevFormData => ({
                                  ...prevFormData,
                                  meeting_type: parseInt(e.target.value),
                                }));
                              }}
                              name="interviewType"
                              className="form-select form-control"
                              data-width="100%"
                              data-size="10"
                              title={t(`ATS View.Select Interview Type`)}
                              value={formData?.meeting_type}
                            >
                              <option value={0}>{t(`ATS View.Offline`)}</option>
                              <option value={1}>{t(`ATS View.Online`)}</option>
                            </select>
                          </div>
                        </Col>
                        {formData?.meeting_type === 1 && teamsIntegrated && (
                          <Col md={6}>
                            <label> {t(`ATS View.Schedule on Teams`)}:</label>{" "}
                            <br />
                            <div className="">
                              <label
                                className="switch mt-3"
                                htmlFor={"tableSwitch"}
                              >
                                <input
                                  type="checkbox"
                                  id={`tableSwitch`}
                                  onClick={e => {
                                    setFormData(prevFormData => ({
                                      ...prevFormData,
                                      teams_interview: e.target.checked,
                                    }));
                                  }}
                                  checked={formData?.teams_interview}
                                />
                                <div className="slider round"></div>
                              </label>
                            </div>
                          </Col>
                        )}

                        <div
                          id="address-group"
                          className="form-group form-group-lg col-sm-6 formvisible"
                        >
                          {formData?.meeting_type === 0 && (
                            <>
                              <label>
                                {" "}
                                {t(`ATS View.Enter Offline Address`)}:
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                onChange={changeHandlers}
                                name="address"
                                id="address"
                                placeholder={t(`ATS View.Enter Address`)}
                                value={formData?.address}
                              />
                              {errors?.address && (
                                <p className="text-danger">{errors?.address}</p>
                              )}
                            </>
                          )}
                          {formData?.meeting_type === 1 &&
                            !formData?.teams_interview && (
                              <>
                                <label> {t(`ATS View.Meeting Link`)}:</label>{" "}
                                <br />
                                <input
                                  type="text"
                                  className="form-control"
                                  onChange={changeHandlers}
                                  name="address"
                                  id="address"
                                  placeholder={t(`ATS View.Enter Meeting Link`)}
                                  value={formData?.address}
                                />
                                {errors?.address && (
                                  <p className="text-danger">
                                    {errors?.address}
                                  </p>
                                )}
                              </>
                            )}
                        </div>
                        <div
                          id="req_documents-group"
                          className="form-group form-group-lg col-sm-12 formvisible mt-3"
                        >
                          <label>
                            {t(`ATS View.Required Documents (If Any)`)}
                          </label>
                          <textarea
                            type="text"
                            className="form-control"
                            onChange={changeHandlers}
                            name="req_documents"
                            id="req_documents"
                            placeholder={t(`ATS View.Mention Documents Needed`)}
                            value={formData?.req_documents}
                          ></textarea>
                          {errors?.req_documents && (
                            <p className="text-danger">
                              {errors?.req_documents}
                            </p>
                          )}
                        </div>
                      </Row>
                    </div>
                  </div>
                  <div className="modal-action-btn text-left  mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary mb-2"
                      id="book_schedule"
                    >
                      {t(`ATS View.Submit`)}
                    </button>
                  </div>
                </Form>
              </Modal.Body>
            </Modal>
          </div>
        </Container>

        {showNotes && (
          <>
            <div className="edit-modal">
              <Modal
                show={showNotes}
                onHide={handleCloseModal}
                className="edit-modal-card interview_Notes"
              >
                {/* <Modal.Header closeButton></Modal.Header> */}
                <Modal.Body>
                  <div className="filters-cards-cross">
                    <div className="filter-content">
                      <h4>Interview Notes</h4>
                    </div>
                    <div
                      className="filter-content cross"
                      onClick={() => {
                        handleCloseModal();
                        setAssessmentModal(true);
                      }}
                    >
                      <img src={cross} alt="" />
                    </div>
                  </div>
                  <div className="bordertops"></div>
                  <div className="interview-notes-cards">
                    <div className="row">
                      {allNotes?.length > 0 &&
                        allNotes?.map(el => {
                          return (
                            <Col lg={12} className="mb-2">
                              <div className="chat-nots-card">
                                <div className="chat-header">
                                  <div>
                                    <h6>{el?.user?.name || ""} </h6>
                                    <p>({el?.user?.email || ""}) </p>
                                  </div>
                                  <div
                                    className="delete-icon cursor-pointer"
                                    title={t(`View Details.Remove Note`)}
                                    onClick={() => handleRemoveNote(el)}
                                  >
                                    <span>
                                      <img
                                        src={delete_icon}
                                        alt="delete icon"
                                      />
                                    </span>
                                  </div>
                                </div>
                                <div className="chat-comment">
                                  <p>
                                    {readMoreStates[el.id]
                                      ? el?.note
                                      : `${el?.note.substring(0, 250)}`}

                                    {el?.note.length > 250 && (
                                      <button
                                        onClick={() => toggleReadMore(el.id)}
                                        className="btn btn-link"
                                      >
                                        {readMoreStates[el.id]
                                          ? t(`View Details.Read Less`)
                                          : t(`View Details.Read More`)}
                                      </button>
                                    )}
                                  </p>
                                </div>

                                <div className="chat-footer">
                                  <div className="chat-calender">
                                    {/* <span>
                                    <img src={calednder} alt="" />
                                  </span> */}
                                    <p>
                                      {el?.createdAt
                                        ? moment(
                                            getCompanyTimezoneDateTime(
                                              el?.createdAt
                                            )
                                          ).format("Do MMM'YY | hh:mm a")
                                        : ""}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          );
                        })}
                      {allNotes?.length === 0 && (
                        <>
                          <div className="no-data data-available">
                            <img
                              src="../../img/data-not-available.png"
                              alt="data not available"
                            />
                            <h3>{t(`View Details.No Item Found`)}</h3>
                            <p>
                              {t(`View Details.Sorry, we could not find any`)}
                              <br />
                              {t(`View Details.Item to show here`)}
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </>
        )}
      </div>
      {/* reject data popup */}
      {isReject && (
        <div className="filter-shadow reject-people-data">
          {/* ✅ backdrop FIRST */}
          <div className="black-showd" onClick={reject_close}></div>

          <div className="filters-cards">
            <div className="filters-cards-cross">
              <div className="filter-content">
                <h4>
                  {actionType === "reject"
                    ? t("all-application.Reject Application")
                    : t("all-application.Shortlist Application")}
                </h4>
              </div>
              <div className="filter-content cross" onClick={reject_close}>
                <img src={cross} alt="" />
              </div>
            </div>

            <div className="reject-people data">
              <div className="data-people">
                <div className="people-biodata">
                  <div className="icon-name">
                    <img src={name_icon} alt="" />
                  </div>
                  <div className="people-name">
                    <p>{t("all-application.Name")}</p>
                    <h4>{candidateDetails.name}</h4>
                  </div>
                </div>

                <div className="people-biodata">
                  <div className="icon-name">
                    <img src={job} alt="" />
                  </div>
                  <div className="people-name">
                    <p>{t("all-application.Job Role")}</p>
                    <h4>{candidateDetails.vacancy?.title}</h4>
                  </div>
                </div>
              </div>

              <div className="data-people">
                <div className="people-biodata">
                  <div className="icon-name">
                    <img src={education} alt="" />
                  </div>
                  <div className="people-name">
                    <p>{t("all-application.Education")}</p>
                    <h4>
                      {
                        candidateDetails.master_reference_table
                          ?.highest_qualification
                      }
                    </h4>
                  </div>
                </div>

                <div className="people-biodata">
                  <div className="icon-name">
                    <img src={star_exp} alt="" />
                  </div>
                  <div className="people-name">
                    <p>{t("all-application.Total Exp")}</p>
                    <h4>{candidateDetails.job_user?.total_experience}</h4>
                  </div>
                </div>
              </div>
            </div>

            <div className="filter-cards-form reject-data">
              <h4>
                {actionType === "reject"
                  ? t("all-application.Reject Candidate confirmation")
                  : t("all-application.Shortlist Candidate confirmation")}
              </h4>

              <p>
                {actionType === "reject"
                  ? t("all-application.Reject Candidate msg")
                  : t("all-application.Shortlist Candidate msg")}
              </p>

              {actionType === "reject" && (
                <Form.Group className="form-considere mb-2">
                  <Form.Label>Rejected Remark</Form.Label>
                  <Form.Select
                    value={selectedRemark?.id || ""}
                    onChange={handleRemarkChange}
                  >
                    <option value="">Select rejection reason</option>
                    {remarks.map(r => (
                      <option key={r.id} value={r.id}>
                        {r.remark_label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}

              <form className="form-inline">
                <div className="col-lg-12">
                  {/* {actionType !== "reject" && (
                    <Form.Group className="form-considere">
                      <Form.Check
                        type="checkbox"
                        label="Require comment"
                        checked={isCommentRequired}
                        onChange={toggleCommentRequirement}
                      />
                    </Form.Group>
                  )} */}

                  <textarea
                    className="form-control"
                    rows="3"
                    name="comment"
                    value={comment}
                    onChange={e => setComment(e.target.value)}
                    placeholder={
                      actionType === "reject"
                        ? selectedRemark?.is_comment_required
                          ? t("all-application.Reject Comment")
                          : t("all-application.Optional Comment")
                        : t("all-application.Shortlist Comment")
                    }
                  />

                  {commentError && (
                    <div className="text-danger">{commentError}</div>
                  )}
                </div>

                <div className="col-lg-12">
                  <div className="serach-btn">
                    <a
                      href="javascript:void(0);"
                      className="nxt_prev_ques btn btn-primary btn-lg next-btn"
                      onClick={handleActionSubmit}
                    >
                      {actionType === "reject"
                        ? t("all-application.Reject")
                        : actionType === "shortlist"
                        ? t("all-application.shortlist")
                        : t("all-application.Select")}
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
